export const culure_syncfusion_ar = {
  "grid": {
    "EmptyRecord": "لا سجلات لعرضها",
    "True": "صحيح",
    "False": "خاطئة",
    "InvalidFilterMessage": "بيانات تصفية غير صالحة",
    "GroupDropArea": "اسحب رأس العمود إلى هنا لتخصيص العرض ..  ",
    "UnGroup": "انقر هنا لإلغاء التجميع",
    "GroupDisable": "تم تعطيل التجميع لهذا العمود",
    "FilterbarTitle": "خلية شريط مرشح",
    "EmptyDataSourceError": "يجب ألا يكون DataSource فارغًا عند التحميل الأولي نظرًا لأن الأعمدة يتم إنشاؤها من DataSource في شبكة إنشاء عمود تلقائي",
    "Add": "إضافة",
    "Edit": "تعديل",
    "Cancel": "إلغاء",
    "Update": "تحديث",
    "Delete": "حذف",
    "Print": "طباعة",
    "Pdfexport": "استخراج PDF",
    "Excelexport": "استخراج ملف إكسيل",
    "Wordexport": "استخراج ملف وورد",
    "Csvexport": "استخراج CSV",
    "Search": "بحـــث..",
    "Columnchooser": "أعمدة",
    "Save": "حفظ",
    "Item": "بند",
    "Items": "العناصر",
    "EditOperationAlert": "لم يتم تحديد سجلات لعملية التحرير",
    "DeleteOperationAlert": "لم يتم تحديد سجلات لعملية الحذف",
    "SaveButton": "حفظ",
    "OKButton": "حسنا",
    "CancelButton": "إلغاء",
    "EditFormTitle": "تفاصيل",
    "AddFormTitle": "إضافة سجل جديد",
    "BatchSaveConfirm": "هل أنت متأكد أنك تريد حفظ التغييرات؟",
    "BatchSaveLostChanges": "سيتم فقد التغييرات غير المحفوظة. هل أنت متأكد أنك تريد المتابعة؟",
    "ConfirmDelete": "هل أنت متأكد أنك تريد حذف السجل؟",
    "CancelEdit": "هل أنت متأكد من أنك تريد إلغاء التغييرات؟",
    "ChooseColumns": "اختيار العمود",
    "SearchColumns": "أعمدة البحث",
    "Matchs": "لم يتم العثور على تطابق",
    "FilterButton": "فلتــر",
    "ClearButton": "إلغــاء",
    "StartsWith": "ابدا ب",
    "EndsWith": "ينتهي بـ",
    "Contains": "يحتوي على",
    "Equal": "مساو",
    "NotEqual": "ليس متساوي",
    "LessThan": "أقل من",
    "LessThanOrEqual": "اصغر من او يساوي",
    "GreaterThan": "أكثر من",
    "GreaterThanOrEqual": "أكبر من أو يساوي",
    "ChooseDate": "اختيار التاريخ",
    "EnterValue": "أدخل القيمة",
    "Copy": "نسخ",
    "Group": "تجميع حسب هذا العمود",
    "Ungroup": "فك التجميع بواسطة هذا العمود",
    "autoFitAll": "احتواء تلقائي لجميع الأعمدة",
    "autoFit": "احتواء تلقائي لهذا العمود",
    "Export": "تصدير",
    "FirstPage": "الصفحة الأولى",
    "LastPage": "آخر صفحة",
    "PreviousPage": "الصفحة السابقة",
    "NextPage": "الصفحة التالية",
    "SortAscending": "فرز تصاعدي",
    "SortDescending": "ترتيب تنازلي",
    "EditRecord": "تحرير السجل",
    "DeleteRecord": "حذف سجل",
    "FilterMenu": "منقي",
    "SelectAll": "اختر الكل",
    "Blanks": "الفراغات",
    "FilterTrue": "صحيح",
    "FilterFalse": "خاطئة",
    "NoResult": "لم يتم العثور على تطابق",
    "ClearFilter": "مرشح واضح",
    "NumberFilter": "عدد المرشحات",
    "TextFilter": "مرشحات النص",
    "DateFilter": "مرشحات التاريخ",
    "DateTimeFilter": "مرشحات DateTime",
    "MatchCase": "حالة التشابه",
    "Between": "بين",
    "CustomFilter": "فلتــر مخصص",
    "CustomFilterPlaceHolder": "أدخل القيمة",
    "CustomFilterDatePlaceHolder": "اختيار تاريـخ",
    "AND": "و",
    "OR": "أو",
    "ShowRowsWhere": "إظهار البيانات حيث:",
    "NotStartsWith": "لا تبدأ بـ",
    "Like": "مــثل",
    "NotEndsWith": "لا ينتهي بـ",
    "NotContains": "  لا يحتــوي على",
    "IsNull": "فارغ",
    "NotNull": "غير فارغة",
    "IsEmpty": "فارغ",
    "IsNotEmpty": "ليس فارغًا",
    "AddCurrentSelection": "إضافة التحديد الحالي للتصفية",
    "UnGroupButton": "انقر هنا لفك التجميع",
    "AutoFitAll": "احتواء تلقائي لجميع الأعمدة",
    "AutoFit": "احتواء تلقائي لهذا العمود",
    "Clear": "صافي",
    "FilterMenuDialogARIA": "مربع حوار قائمة التصفية",
    "ExcelFilterDialogARIA": "مربع حوار مرشح Excel",
    "DialogEditARIA": "مربع حوار التحرير",
    "ColumnChooserDialogARIA": "منتقي الأعمدة",
    "ColumnMenuDialogARIA": "مربع حوار قائمة العمود",
    "CustomFilterDialogARIA": "مربع حوار عامل التصفية المخصص",
    "SortAtoZ": "فرز من الألف إلى الياء",
    "SortZtoA": "فرز من Z إلى A",
    "SortByOldest": "فرز حسب الأقدم",
    "SortByNewest": "فرز حسب الأحدث",
    "SortSmallestToLargest": "الفرز من الأصغر إلى الأكبر",
    "SortLargestToSmallest": "الفرز من الأكبر إلى الأصغر",
    "Sort": "فرز",
    "FilterDescription": "اضغط على Alt Down لفتح قائمة التصفية",
    "SortDescription": "اضغط على Enter للفرز",
    "ColumnMenuDescription": "اضغط على Alt لأسفل لفتح قائمة العمود",
    "GroupDescription": "اضغط على مفتاح Ctrl مسافة للمجموعة",
    "ColumnHeader": " رأس العمود ",
    "TemplateCell": " هي خلية قالب",
    "CommandColumnAria": "هو رأس عمود الأمر ",
    "DialogEdit": "تحرير الحوار",
    "ClipBoard": "المحفظة",
    "GroupButton": "زر المجموعة",
    "UnGroupAria": "زر فك التجميع",
    "GroupSeperator": "فاصل للأعمدة المجمعة",
    "UnGroupIcon": "قم بفك تجميع العمود المجمع ",
    "GroupedSortIcon": "قم بفرز العمود المجمع ",
    "GroupedDrag": "اسحب العمود المجمع",
    "GroupCaption": " هي خلية تسمية توضيحية جماعية",
    "CheckBoxLabel": "خانة الاختيار",
    "Expanded": "موسع",
    "Collapsed": "انهار"
  },
  "pager": {
    "currentPageInfo": "{0} من {1} صفحة",
    "totalItemsInfo": "({0} عناصر)",
    "firstPageTooltip": "الذهاب إلى الصفحة الأولى",
    "lastPageTooltip": "الذهاب إلى الصفحة الأخيرة",
    "nextPageTooltip": "انتقل إلى الصفحة التالية",
    "previousPageTooltip": "الانتقال إلى الصفحة السابقة",
    "nextPagerTooltip": "انتقل إلى عناصر بيجر التالية",
    "previousPagerTooltip": "انتقل إلى عناصر بيجر السابقة",
    "pagerDropDown": "عناصر لكل صفحة",
    "pagerAllDropDown": "العناصر",
    "All": "الكل",
    "totalItemInfo": "({0} بند)",
    "Container": "حاوية بيجر",
    "Information": "معلومات جهاز النداء",
    "ExternalMsg": "رسالة خارجية بيجر",
    "Page": "صفحة ",
    "Of": " من ",
    "Pages": " الصفحات"
  },
  "kanban": {
    "items": "العناصر",
    "min": "دقيقة",
    "max": "ماكس",
    "cardsSelected": "تم اختيار البطاقات",
    "addTitle": "إضافة بطاقة جديدة",
    "editTitle": "تحرير تفاصيل البطاقة",
    "deleteTitle": "حذف البطاقة",
    "deleteContent": "هل أنت متأكد أنك تريد حذف هذه البطاقة؟",
    "save": "حفظ",
    "delete": "حذف",
    "cancel": "إلغاء",
    "yes": "نعم",
    "no": "لا",
    "close": "قريب",
    "noCard": "لا توجد بطاقات لعرضها",
    "unassigned": "غير معين"
  },
  "dropdowns": {
    "noRecordsTemplate": "لا توجد سجلات",
    "actionFailureTemplate": "فشل الطلب",
    "overflowCountTemplate": "+${count} المزيد ..",
    "selectAllText": "اختر الكل",
    "unSelectAllText": "إلغاء تحديد الكل",
    "totalCountTemplate": "تم تحديد ${count}"
  },
  "drop-down-list": {
    "noRecordsTemplate": "لا توجد سجلات",
    "actionFailureTemplate": "فشل الطلب"
  },
  "combo-box": {
    "noRecordsTemplate": "لا توجد سجلات",
    "actionFailureTemplate": "فشل الطلب"
  },
  "auto-complete": {
    "noRecordsTemplate": "لا توجد سجلات",
    "actionFailureTemplate": "فشل الطلب"
  },
  "multi-select": {
    "noRecordsTemplate": "لا توجد سجلات",
    "actionFailureTemplate": "فشل الطلب",
    "overflowCountTemplate": "+${count} المزيد ..",
    "selectAllText": "اختر الكل",
    "unSelectAllText": "إلغاء تحديد الكل",
    "totalCountTemplate": "تم تحديد ${count}"
  },
  "listbox": {
    "noRecordsTemplate": "لا توجد سجلات",
    "actionFailureTemplate": "فشل الطلب",
    "selectAllText": "اختر الكل",
    "unSelectAllText": "إلغاء تحديد الكل",
    "moveUp": "تحرك",
    "moveDown": "تحرك لأسفل",
    "moveTo": "الانتقال إلى",
    "moveFrom": "انتقل من",
    "moveAllTo": "نقل الكل إلى",
    "moveAllFrom": "نقل الكل من"
  },
  "spreadsheet": {
    "InsertingEmptyValue": "القيمة المرجعية غير صحيحة.",
    "FindValue": "ابحث عن قيمة",
    "ReplaceValue": "استبدل القيمة",
    "FindReplaceTooltip": "البحث والاستبدال",
    "ByRow": "بالصفوف",
    "ByColumn": "حسب الأعمدة",
    "MatchExactCellElements": "تطابق محتويات الخلية بأكملها",
    "EnterCellAddress": "أدخل عنوان الخلية",
    "FindAndReplace": "البحث والاستبدال",
    "ReplaceAllEnd": " تم استبدال المطابقات بـ",
    "FindNextBtn": "بحث عن التالي",
    "FindPreviousBtn": "البحث عن السابق",
    "ReplaceBtn": "يحل محل",
    "ReplaceAllBtn": "استبدل الكل",
    "GotoHeader": "اذهب إلى",
    "Sheet": "ملزمة",
    "SearchWithin": "بحث داخل",
    "SearchBy": "البحث عن طريق",
    "Reference": "المرجعي",
    "Workbook": "دفتر العمل",
    "NoElements": "لم نتمكن من العثور على ما كنت تبحث عنه.",
    "FindWhat": "اوجد ماذا",
    "ReplaceWith": "استبدل ب",
    "FileName": "اسم الملف",
    "ExtendValidation": "يحتوي التحديد على بعض الخلايا بدون التحقق من صحة البيانات. هل تريد تمديد التحقق إلى هذه الخلايا؟",
    "Yes": "نعم",
    "No": "رقم",
    "PROPER": "يحول النص إلى حالة الأحرف المناسبة ؛ الحرف الأول إلى الأحرف الكبيرة والحروف الأخرى إلى الأحرف الصغيرة.",
    "Cut": "قطع",
    "Copy": "ينسخ",
    "Paste": "لـصق",
    "PasteSpecial": "لصق خاص",
    "All": "الجميع",
    "Values": "قيم",
    "Formats": "التنسيقات",
    "Font": "الخط",
    "FontSize": "حجم الخط",
    "Bold": "عريض",
    "Italic": "مائل",
    "Underline": "تسطير",
    "Strikethrough": "يتوسطه خط",
    "TextColor": "لون الخط",
    "FillColor": "لون التعبئة",
    "HorizontalAlignment": "المحاذاة الأفقية",
    "AlignLeft": "محاذاة لليسار",
    "AlignCenter": "مركز",
    "AlignRight": "محاذاة اليمين",
    "VerticalAlignment": "انحياز عمودي",
    "AlignTop": "محاذاة للأعلى",
    "AlignMiddle": "محاذاة الأوسط",
    "AlignBottom": "محاذاة لأسفل",
    "MergeCells": "دمج الخلايا",
    "MergeAll": "دمج الكل",
    "MergeHorizontally": "دمج أفقيًا",
    "MergeVertically": "دمج عموديا",
    "Unmerge": "اندمج",
    "UnmergeCells": "فك دمج الخلايا",
    "SelectMergeType": "حدد نوع الدمج",
    "MergeCellsAlert": "سيؤدي دمج الخلايا إلى الاحتفاظ بالقيمة العلوية اليسرى (العلوية) فقط. هل تريد الدمج على أي حال؟",
    "PasteMergeAlert": "لا يمكننا فعل ذلك لخلية دمج.",
    "Borders": "الحدود",
    "TopBorders": "أعلى الحدود",
    "LeftBorders": "الحدود اليسرى",
    "RightBorders": "الحدود اليمنى",
    "BottomBorders": "الحدود السفلية",
    "AllBorders": "كل الحدود",
    "HorizontalBorders": "الحدود الأفقية",
    "VerticalBorders": "حدود عمودية",
    "OutsideBorders": "الحدود الخارجية",
    "InsideBorders": "داخل الحدود",
    "NoBorders": "لا حدود",
    "BorderColor": "لون الحدود",
    "BorderStyle": "نمط الحدود",
    "InsertFunction": "أدخل الوظيفة",
    "Insert": "إدراج",
    "Delete": "حذف",
    "DuplicateSheet": "ينسخ",
    "MoveRight": "تحرك يمينا",
    "MoveLeft": "تحرك يسارا",
    "Rename": "إعادة تسمية",
    "Hide": "إخفاء",
    "NameBox": "مربع الاسم",
    "ShowHeaders": "إظهار الرؤوس",
    "HideHeaders": "إخفاء الرؤوس",
    "ShowGridLines": "اظهر خطوط الشبكة",
    "HideGridLines": "إخفاء خطوط الشبكة",
    "FreezePanes": "أجزاء التجميد",
    "FreezeRows": "تجميد الصفوف",
    "FreezeColumns": "أعمدة التجميد",
    "UnfreezePanes": "إلغاء تجميد الأجزاء",
    "UnfreezeRows": "إلغاء تجميد الصفوف",
    "UnfreezeColumns": "قم بإلغاء تجميد الأعمدة",
    "AddSheet": "أضف ورقة",
    "ListAllSheets": "سرد كافة الأوراق",
    "CollapseToolbar": "طي شريط الأدوات",
    "ExpandToolbar": "قم بتوسيع شريط الأدوات",
    "CollapseFormulaBar": "طي شريط الصيغة",
    "ExpandFormulaBar": "قم بتوسيع شريط الصيغة",
    "File": "ملف",
    "Home": "مسكن",
    "Formulas": "الصيغ",
    "View": "رأي",
    "New": "جديد",
    "Open": "يفتح",
    "SaveAs": "حفظ باسم",
    "ExcelXlsx": "مايكروسوفت اكسل",
    "ExcelXls": "مايكروسوفت اكسل 97-2003",
    "CSV": "قيم مفصولة بفواصل",
    "FormulaBar": "شريط الصيغة",
    "Sort": "نوع",
    "SortAscending": "تصاعدي",
    "SortDescending": "تنازلي",
    "CustomSort": "فرز مخصص",
    "AddColumn": "أضف عمود",
    "ContainsHeader": "تحتوي البيانات على العنوان",
    "CaseSensitive": "حساسية الموضوع",
    "SortBy": "ترتيب حسب",
    "ThenBy": "ثم بواسطة",
    "SelectAColumn": "حدد عمودًا",
    "SortEmptyFieldError": "يجب أن يكون لكل معايير الفرز عمود محدد. تحقق من معايير الفرز المحددة وحاول مرة أخرى.",
    "SortDuplicateFieldError": " يتم فرزها حسب القيم أكثر من مرة. احذف معايير الفرز المكررة وحاول مرة أخرى.",
    "SortOutOfRangeError": "حدد خلية أو نطاقًا داخل النطاق المستخدم وحاول مرة أخرى.",
    "MultiRangeSortError": "لا يمكن القيام بذلك على نطاق متعدد التحديد. حدد نطاقًا واحدًا وحاول مرة أخرى.",
    "HideRow": "إخفاء الصف",
    "HideRows": "إخفاء الصفوف",
    "UnhideRows": "إظهار الصفوف",
    "HideColumn": "إخفاء العمود",
    "HideColumns": "إخفاء الأعمدة",
    "UnhideColumns": "إظهار الأعمدة",
    "InsertRow": "الصف إدراج",
    "InsertRows": "إدراج صفوف",
    "Above": "في الاعلى",
    "Below": "أدناه",
    "InsertColumn": "أدخل العمود",
    "InsertColumns": "أدخل الأعمدة",
    "Before": "قبل",
    "After": "بعد، بعدما",
    "DeleteRow": "احذف صف",
    "DeleteRows": "حذف الصفوف",
    "DeleteColumn": "حذف العمود",
    "DeleteColumns": "حذف الأعمدة",
    "Ok": "نعم",
    "Close": "يغلق",
    "MoreOptions": "المزيد من الخيارات",
    "Cancel": "يلغي",
    "Apply": "تطبيق",
    "MoreColors": "مزيد من الألوان",
    "StandardColors": "ألوان قياسية",
    "General": "عام",
    "Number": "رقم",
    "Currency": "عملة",
    "Accounting": "محاسبة",
    "ShortDate": "التاريخ القصير",
    "LongDate": "تاريخ طويل",
    "Time": "وقت",
    "Percentage": "النسبة المئوية",
    "Fraction": "جزء",
    "Scientific": "علمي",
    "Text": "نص",
    "NumberFormat": "تنسيق الأرقام",
    "MobileFormulaBarPlaceHolder": "أدخل قيمة أو صيغة",
    "PasteAlert": "لا يمكنك لصق هذا هنا ، لأن منطقة النسخ ومنطقة اللصق ليست بنفس الحجم. يرجى محاولة اللصق في نطاق مختلف.",
    "DestroyAlert": "هل تريد بالتأكيد تدمير المصنف الحالي بدون حفظ وإنشاء مصنف جديد؟",
    "SheetRenameInvalidAlert": "يحتوي اسم الورقة على حرف غير صالح.",
    "SheetRenameEmptyAlert": "لا يمكن أن يكون اسم الورقة فارغًا.",
    "SheetRenameAlreadyExistsAlert": "اسم الورقة موجود بالفعل. الرجاء إدخال اسم آخر.",
    "DeleteSheetAlert": "هل أنت متأكد أنك تريد حذف هذه الورقة؟",
    "DeleteSingleLastSheetAlert": "يجب أن يحتوي المصنف على ورقة عمل مرئية واحدة على الأقل.",
    "PickACategory": "اختر فئة",
    "Description": "وصف",
    "UnsupportedFile": "ملف غير مدعم",
    "DataLimitExceeded": "بيانات الملف كبيرة جدًا وتستغرق المعالجة وقتًا أطول ، هل تريد المتابعة؟",
    "FileSizeLimitExceeded": "حجم الملف كبير جدًا وتستغرق المعالجة وقتًا أطول ، هل تريد المتابعة؟",
    "InvalidUrl": "URL غير صالح",
    "SUM": "يضيف سلسلة من الأرقام و / أو الخلايا.",
    "SUMIF": "يضيف الخلايا بناءً على الشرط المحدد.",
    "SUMIFS": "يضيف الخلايا بناءً على الشروط المحددة.",
    "ABS": "إرجاع قيمة رقم بدون علامته.",
    "RAND": "تُرجع رقمًا عشوائيًا بين 0 و 1.",
    "RANDBETWEEN": "يُرجع عددًا صحيحًا عشوائيًا بناءً على قيم محددة.",
    "FLOOR": "لتقريب رقم لأسفل إلى أقرب مضاعف لعامل معين.",
    "CEILING": "لتقريب رقم للأعلى إلى أقرب مضاعف لعامل معين.",
    "PRODUCT": "يضاعف سلسلة من الأرقام و / أو الخلايا.",
    "AVERAGE": "تحسب المتوسط ​​لسلسلة الأرقام و / أو الخلايا باستثناء النص.",
    "AVERAGEIF": "تحسب متوسط ​​الخلايا بناءً على معيار محدد.",
    "AVERAGEIFS": "تحسب متوسط ​​الخلايا بناءً على الشروط المحددة.",
    "AVERAGEA": "لحساب متوسط ​​الخلايا التي تقيم TRUE على أنها 1 والنص و FALSE على أنها 0.",
    "COUNT": "تحسب الخلايا التي تحتوي على قيم رقمية في نطاق.",
    "COUNTIF": "تحسب الخلايا على أساس الشرط المحدد.",
    "COUNTIFS": "تحسب الخلايا بناءً على الشروط المحددة.",
    "COUNTA": "تحسب الخلايا التي تحتوي على قيم في نطاق.",
    "MIN": "إرجاع أصغر عدد من الوسيطات المحددة.",
    "MAX": "تُرجع أكبر عدد من الوسيطات المحددة.",
    "DATE": "إرجاع التاريخ بناءً على السنة والشهر واليوم المحدد.",
    "DAY": "إرجاع اليوم من التاريخ المحدد.",
    "DAYS": "ترجع عدد الأيام بين تاريخين.",
    "IF": "إرجاع القيمة بناءً على التعبير المحدد.",
    "IFS": "تُرجع القيمة بناءً على التعبيرات المتعددة المحددة.",
    "CalculateAND": "تُرجع TRUE إذا كانت كل الوسيطات هي TRUE ، وبخلاف ذلك تُرجع FALSE.",
    "CalculateOR": "تُرجع TRUE إذا كانت أي من الوسيطات هي TRUE ، وبخلاف ذلك تُرجع FALSE.",
    "IFERROR": "إرجاع القيمة إذا لم يتم العثور على خطأ وإلا فإنه سيعيد القيمة المحددة.",
    "CHOOSE": "تُرجع قيمة من قائمة القيم ، بناءً على رقم الفهرس.",
    "INDEX": "ترجع قيمة خلية في نطاق معين بناءً على رقم الصف والعمود.",
    "FIND": "تُرجع موضع سلسلة ضمن سلسلة أخرى ، والتي تكون حساسة لحالة الأحرف.",
    "CONCATENATE": "يجمع بين سلسلتين أو أكثر معًا.",
    "CONCAT": "يربط قائمة أو نطاقًا من السلاسل النصية.",
    "SUBTOTAL": "إرجاع المجموع الفرعي لنطاق باستخدام رقم دالة محدد.",
    "RADIANS": "تحويل الدرجات إلى راديان.",
    "MATCH": "تُرجع الموضع النسبي لقيمة محددة في نطاق معين.",
    "SLOPE": "إرجاع ميل الخط من الانحدار الخطي لنقاط البيانات.",
    "INTERCEPT": "تحسب نقطة خط التقاطع ص عبر الانحدار الخطي.",
    "UNIQUE": "تُرجع قيمًا فريدة من نطاق أو مصفوفة",
    "TEXT": "يحول قيمة إلى نص بتنسيق رقم محدد.",
    "DefineNameExists": "هذا الاسم موجود بالفعل ، جرب اسمًا مختلفًا.",
    "CircularReference": "عندما تشير الصيغة إلى مرجع معاد واحد أو أكثر ، فقد ينتج عن ذلك حساب غير صحيح.",
    "SORT": "يفرز نطاق من المصفوفة",
    "T": "للتحقق مما إذا كانت القيمة نصية أم لا وإرجاع النص.",
    "EXACT": "للتحقق مما إذا كانت سلسلتان نصيتان متماثلتان تمامًا وإرجاع TRUE أو FALSE.",
    "LEN": "تُرجع عددًا من الأحرف في سلسلة معينة.",
    "MOD": "تُرجع الباقي بعد قسمة رقم على القاسم.",
    "ODD": "لتقريب رقم موجب إلى أعلى ورقم سالب لأسفل إلى أقرب عدد صحيح فردي.",
    "PI": "ترجع قيمة باي.",
    "COUNTBLANK": "ترجع عدد الخلايا الفارغة في نطاق محدد من الخلايا.",
    "EVEN": "لتقريب رقم موجب إلى أعلى ورقم سالب لأسفل إلى أقرب عدد صحيح زوجي.",
    "DECIMAL": "يحول التمثيل النصي لرقم في أساس معين إلى رقم عشري.",
    "ADDRESS": "تُرجع مرجع خلية كنص ، مع تحديد أرقام الصفوف والأعمدة.",
    "CHAR": "إرجاع الحرف من الرقم المحدد.",
    "CODE": "إرجاع الرمز الرقمي للحرف الأول في سلسلة معينة.",
    "DOLLAR": "تحويل الرقم إلى نص منسق بعملة.",
    "SMALL": "لعرض أصغر قيمة k-th في مصفوفة معينة.",
    "LARGE": "لعرض أكبر قيمة من الدرجة الأولى في مصفوفة معينة.",
    "TIME": "تحويل الساعات والدقائق والثواني إلى الوقت المنسق للنص.",
    "DEGREES": "تحويل التقدير الدائري إلى درجات.",
    "FACT": "إرجاع مضروب رقم.",
    "MEDIAN": "إرجاع الوسيط لمجموعة الأرقام المحددة.",
    "EDATE": "إرجاع تاريخ بعدد الأشهر المحدد قبل التاريخ المحدد أو بعده.",
    "DATEVALUE": "يحول سلسلة التاريخ إلى قيمة التاريخ.",
    "NOW": "إرجاع التاريخ والوقت الحاليين.",
    "HOUR": "ترجع عدد الساعات في سلسلة زمنية محددة.",
    "MINUTE": "ترجع عدد الدقائق في سلسلة زمنية محددة.",
    "SECOND": "ترجع عدد الثواني في سلسلة زمنية محددة.",
    "MONTH": "ترجع عدد الأشهر في سلسلة تاريخ محددة.",
    "OR": "أو",
    "AND": "و",
    "CustomFilterDatePlaceHolder": "اختر التاريخ",
    "CustomFilterPlaceHolder": "أدخل القيمة",
    "CustomFilter": "تصفية مخصص",
    "Between": "ما بين",
    "MatchCase": "حالة مباراة",
    "DateTimeFilter": "مرشحات DateTime",
    "Undo": "الغاء التحميل",
    "Redo": "إعادة",
    "ClearAllFilter": "صافي",
    "ReapplyFilter": "أعد تطبيق",
    "DateFilter": "مرشحات التاريخ",
    "TextFilter": "مرشحات النص",
    "NumberFilter": "مرشحات الرقم",
    "ClearFilter": "مرشح واضح",
    "NoResult": "لم يتم العثور على تطابق",
    "FilterFalse": "خطأ شنيع",
    "FilterTrue": "حقيقي",
    "Blanks": "الفراغات",
    "SelectAll": "اختر الكل",
    "GreaterThanOrEqual": "أكبر من أو يساوي",
    "GreaterThan": "أكثر من",
    "LessThanOrEqual": "اصغر من او يساوي",
    "LessThan": "أقل من",
    "NotEqual": "ليس متساوي",
    "Equal": "متساوي",
    "Contains": "يتضمن",
    "NotContains": "لا يحتوي على",
    "EndsWith": "ينتهي بـ",
    "NotEndsWith": "لا تنتهي بـ",
    "StartsWith": "يبدأ بـ",
    "NotStartsWith": "لا يبدأ بـ",
    "IsEmpty": "فارغ",
    "IsNotEmpty": "ليس فارغًا",
    "ClearButton": "صافي",
    "FilterButton": "منقي",
    "CancelButton": "يلغي",
    "OKButton": "نعم",
    "Search": "يبحث",
    "DataValidation": "تأكيد صحة البيانات",
    "CellRange": "نطاق الخلايا",
    "Allow": "السماح",
    "Data": "بيانات",
    "Minimum": "الحد الأدنى",
    "Maximum": "أقصى",
    "IgnoreBlank": "تجاهل الفراغ",
    "WholeNumber": "الرقم كاملا",
    "Decimal": "عدد عشري",
    "Date": "تاريخ",
    "TextLength": "طول النص",
    "List": "قائمة",
    "NotBetween": "ليس بينهما",
    "EqualTo": "يساوي",
    "NotEqualTo": "لا يساوي",
    "GreaterThanOrEqualTo": "أكبر من أو يساوي",
    "LessThanOrEqualTo": "اقل او يساوي",
    "InCellDropDown": "القائمة المنسدلة في الخلية",
    "Sources": "مصادر",
    "Value": "قيمة",
    "Retry": "أعد المحاولة",
    "DialogError": "يجب أن يكون مصدر القائمة مرجعًا لصف أو عمود واحد.",
    "MinMaxError": "يجب أن يكون الحد الأقصى أكبر من أو يساوي الحد الأدنى.",
    "Spreadsheet": "جدول",
    "MoreValidation": "يحتوي هذا التحديد على أكثر من عملية تحقق واحدة.",
    "FileNameError": "لا يمكن أن يحتوي اسم الملف على أحرف مثل \\ /: *؟ \"<> [] |",
    "ValidationError": "لا تتطابق هذه القيمة مع قيود التحقق من صحة البيانات المحددة للخلية.",
    "ListLengthError": "تسمح قيم القائمة بحد أقصى 256 حرفًا",
    "ProtectSheet": "ورقة حماية",
    "UnprotectSheet": "ورقة غير محمية",
    "SelectCells": "حدد الخلايا المؤمنة",
    "SelectUnlockedCells": "حدد الخلايا غير المؤمنة",
    "Save": "يحفظ",
    "EmptyFileName": "لا يمكن أن يكون اسم الملف فارغًا.",
    "LargeName": "اسم طويل جدا.",
    "FormatCells": "تنسيق الخلايا",
    "FormatRows": "تنسيق الصفوف",
    "FormatColumns": "تنسيق الأعمدة",
    "InsertLinks": "أدخل الروابط",
    "ProtectContent": "حماية محتويات الخلايا المقفلة",
    "ProtectAllowUser": " السماح لكافة مستخدمي ورقة العمل هذه بما يلي:",
    "EditAlert": "الخلية التي تحاول تغييرها محمية. لإجراء تغيير ، قم بإلغاء حماية الورقة.",
    "ClearValidation": "التحقق من الصحة واضح",
    "ISNUMBER": "إرجاع صحيح عندما يتم تحليل القيمة كقيمة رقمية.",
    "ROUND": "لتقريب رقم إلى عدد محدد من الأرقام.",
    "GEOMEAN": "إرجاع الوسط الهندسي لصفيف أو نطاق من البيانات الموجبة.",
    "POWER": "تُرجع نتيجة رقم مرفوع إلى أس",
    "LOG": "إرجاع لوغاريتم رقم إلى الأساس الذي تحدده.",
    "TRUNC": "إرجاع القيمة المقطوعة لرقم إلى عدد محدد من المنازل العشرية.",
    "EXP": "تُرجع e المرفوعة إلى قوة الرقم المحدد.",
    "HighlightCellsRules": "تمييز قواعد الخلايا",
    "CFEqualTo": "يساوي",
    "TextThatContains": "النص الذي يحتوي على",
    "ADateOccuring": "حدث تاريخ",
    "DuplicateValues": "قيم مكررة",
    "TopBottomRules": "أعلى / أسفل القواعد",
    "Top10Items": "أهم 10 عناصر",
    "Top10": "أعلى 10",
    "Bottom10Items": "أسفل 10 عناصر",
    "Bottom10": "أسفل 10",
    "AboveAverage": "فوق المتوسط",
    "BelowAverage": "أقل من المتوسط",
    "FormatCellsGreaterThan": "تنسيق الخلايا التي تكون أكبر من:",
    "FormatCellsLessThan": "تنسيق الخلايا الأقل من:",
    "FormatCellsBetween": "تنسيق الخلايا بين:",
    "FormatCellsEqualTo": "تنسيق الخلايا المتساوية مع:",
    "FormatCellsThatContainTheText": "تنسيق الخلايا التي تحتوي على النص:",
    "FormatCellsThatContainADateOccurring": "تنسيق الخلايا التي تحتوي على تاريخ يحدث:",
    "FormatCellsDuplicate": "تنسيق الخلايا التي تحتوي على:",
    "FormatCellsTop": "تنسيق الخلايا التي يتم ترتيبها في TOP:",
    "FormatCellsBottom": "تنسيق الخلايا التي يتم ترتيبها في الأسفل:",
    "FormatCellsAbove": "تنسيق الخلايا التي تكون فوق المتوسط:",
    "FormatCellsBelow": "تنسيق الخلايا أدناه AVERAGE:",
    "With": "مع",
    "DataBars": "أشرطة البيانات",
    "ColorScales": "المقاييس اللونية",
    "IconSets": "مجموعات الرموز",
    "ClearRules": "قواعد واضحة",
    "SelectedCells": "مسح القواعد من الخلايا المحددة",
    "EntireSheet": "مسح القواعد من الورقة بأكملها",
    "LightRedFillWithDarkRedText": "أحمر فاتح تعبئة بنص أحمر غامق",
    "YellowFillWithDarkYellowText": "تعبئة باللون الأصفر بنص أصفر داكن",
    "GreenFillWithDarkGreenText": "تعبئة باللون الأخضر بنص أخضر داكن",
    "RedFill": "التعبئة الحمراء",
    "RedText": "نص أحمر",
    "Duplicate": "ينسخ",
    "Unique": "فريد",
    "And": "و",
    "WebPage": "صفحة ويب",
    "ThisDocument": "هذا المستند",
    "DisplayText": "عرض النص",
    "Url": "URL",
    "CellReference": "مرجع الخلية",
    "DefinedNames": "الأسماء المعرفة",
    "EnterTheTextToDisplay": "أدخل النص المراد عرضه",
    "EnterTheUrl": "أدخل الرابط",
    "INT": "إرجاع رقم إلى أقرب عدد صحيح.",
    "SUMPRODUCT": "إرجاع مجموع حاصل ضرب نطاقات معينة من المصفوفات.",
    "TODAY": "إرجاع التاريخ الحالي كقيمة تاريخ.",
    "ROUNDUP": "لتقريب رقم بعيدًا عن الصفر.",
    "Link": "وصلة",
    "Hyperlink": "ارتباط تشعبي",
    "EditHyperlink": "تحرير الارتباط التشعبي",
    "OpenHyperlink": "افتح الارتباط التشعبي",
    "RemoveHyperlink": "إزالة الارتباط التشعبي",
    "InvalidHyperlinkAlert": "عنوان هذا الموقع غير صالح. تحقق من العنوان ثم حاول مرة أخرى.",
    "InsertLink": "أدخل ارتباط",
    "EditLink": "تحرير الارتباط",
    "WrapText": "دوران النص",
    "Update": "تحديث",
    "SortAndFilter": "فرز وتصفية",
    "Filter": "منقي",
    "FilterCellValue": "تصفية حسب قيمة الخلية المحددة",
    "FilterOutOfRangeError": "حدد خلية أو نطاقًا داخل النطاق المستخدم وحاول مرة أخرى.",
    "ClearFilterFrom": "مسح عامل التصفية من",
    "LN": "إرجاع اللوغاريتم الطبيعي لرقم.",
    "DefineNameInValid": "الاسم الذي أدخلته غير صالح.",
    "EmptyError": "يجب عليك إدخال قيمة",
    "ClearHighlight": "مسح التمييز",
    "HighlightInvalidData": "قم بتمييز البيانات غير الصالحة",
    "Clear": "صافي",
    "ClearContents": "محتويات واضحة",
    "ClearAll": "امسح الكل",
    "ClearFormats": "تنسيقات واضحة",
    "ClearHyperlinks": "مسح الارتباطات التشعبية",
    "Image": "صورة",
    "ConditionalFormatting": "تنسيق مشروط",
    "BlueDataBar": "شريط البيانات الأزرق",
    "GreenDataBar": "شريط البيانات الأخضر",
    "RedDataBar": "شريط البيانات الأحمر",
    "OrangeDataBar": "شريط البيانات البرتقالي",
    "LightBlueDataBar": "شريط بيانات أزرق فاتح",
    "PurpleDataBar": "شريط البيانات الأرجواني",
    "GYRColorScale": "مقياس اللون الأخضر - الأصفر - الأحمر",
    "RYGColorScale": "مقياس اللون الأحمر - الأصفر - الأخضر",
    "GWRColorScale": "مقياس اللون الأخضر - الأبيض - الأحمر",
    "RWGColorScale": "مقياس اللون الأحمر - الأبيض - الأخضر",
    "BWRColorScale": "مقياس اللون الأزرق - الأبيض - الأحمر",
    "RWBColorScale": "مقياس اللون الأحمر - الأبيض - الأزرق",
    "WRColorScale": "مقياس اللون الأبيض والأحمر",
    "RWColorScale": "مقياس اللون الأحمر - الأبيض",
    "GWColorScale": "مقياس اللون الأخضر - الأبيض",
    "WGColorScale": "مقياس اللون الأبيض والأخضر",
    "GYColorScale": "مقياس اللون الأصفر والأخضر",
    "YGColorScale": "مقياس اللون الأصفر والأخضر",
    "ThreeArrowsColor": "3 أسهم (ملونة)",
    "ThreeArrowsGray": "3 أسهم (رمادي)",
    "ThreeTriangles": "3 مثلثات",
    "FourArrowsColor": "4 أسهم (رمادي)",
    "FourArrowsGray": "4 أسهم (ملونة)",
    "FiveArrowsColor": "5 أسهم (رمادي)",
    "FiveArrowsGray": "5 أسهم (ملونة)",
    "ThreeTrafficLights1": "3 إشارات مرور (بدون حواف)",
    "ThreeTrafficLights2": "3 إشارات مرور (ريميد)",
    "ThreeSigns": "3 علامات",
    "FourTrafficLights": "4 إشارات المرور",
    "RedToBlack": "أحمر إلى أسود",
    "ThreeSymbols1": "3 رموز (محاطة بدائرة)",
    "ThreeSymbols2": "3 رموز (غير محاطة بدائرة)",
    "ThreeFlags": "3 أعلام",
    "ThreeStars": "3 نجوم",
    "FourRatings": "4 التقييمات",
    "FiveQuarters": "5 أرباع",
    "FiveRatings": "5 التقييمات",
    "FiveBoxes": "5 علب",
    "Chart": "جدول",
    "Column": "عمود",
    "Bar": "شريط",
    "Area": "مساحة",
    "Pie": "فطيرة",
    "Doughnut": "الدونات",
    "PieAndDoughnut": "فطيرة / دونات",
    "Line": "خط",
    "Radar": "رادار",
    "Scatter": "مبعثر",
    "ChartDesign": "تصميم المخطط",
    "ClusteredColumn": "عمود مجمع",
    "StackedColumn": "عمود مكدس",
    "StackedColumn100": "عمود مكدس بنسبة 100٪",
    "ClusteredBar": "شريط مجمع",
    "StackedBar": "شريط مكدس",
    "StackedBar100": "شريط مكدس بنسبة 100٪",
    "StackedArea": "منطقة مكدسة",
    "StackedArea100": "مساحة مكدسة بنسبة 100٪",
    "StackedLine": "خط مكدس",
    "StackedLine100": "خط مكدس بنسبة 100٪",
    "LineMarker": "خط مع علامات",
    "StackedLineMarker": "خط مكدس بعلامات",
    "StackedLine100Marker": "خط مكدس بنسبة 100٪ بعلامات",
    "AddChartElement": "إضافة عنصر مخطط",
    "Axes": "المحاور",
    "AxisTitle": "عنوان المحور",
    "ChartTitle": "عنوان التخطيط",
    "DataLabels": "تسميات البيانات",
    "Gridlines": "خطوط الشبكة",
    "Legends": "أساطير",
    "PrimaryHorizontal": "أفقي أساسي",
    "PrimaryVertical": "عمودي أساسي",
    "None": "لا أحد",
    "AboveChart": "فوق الرسم البياني",
    "Center": "مركز",
    "InsideEnd": "داخل النهاية",
    "InsideBase": "داخل القاعدة",
    "OutsideEnd": "نهاية خارجية",
    "PrimaryMajorHorizontal": "رئيسي رئيسي أفقي",
    "PrimaryMajorVertical": "رئيسي رئيسي عمودي",
    "PrimaryMinorHorizontal": "أفقي ثانوي أساسي",
    "PrimaryMinorVertical": "عمودي ثانوي أساسي",
    "Right": "حق",
    "Left": "اليسار",
    "Bottom": "الأسفل",
    "Top": "قمة",
    "SwitchRowColumn": "تبديل الصف / العمود",
    "ChartTheme": "موضوع الرسم البياني",
    "ChartType": "نوع التخطيط",
    "Material": "ماتيريال",
    "Fabric": "قماش",
    "Bootstrap": "التمهيد",
    "HighContrastLight": "ضوء عالي التباين",
    "MaterialDark": "مادة الظلام",
    "FabricDark": "نسيج غامق",
    "HighContrast": "تباين عالي",
    "BootstrapDark": "Bootstrap الظلام",
    "Bootstrap4": "التمهيد 4",
    "Bootstrap5Dark": "Bootstrap5 الظلام",
    "Bootstrap5": "التمهيد 5",
    "Tailwind": "الريح الخلفية",
    "TailwindDark": "Tailwind الظلام",
    "VerticalAxisTitle": "عنوان المحور الرأسي",
    "HorizontalAxisTitle": "عنوان المحور الأفقي",
    "EnterTitle": "أدخل العنوان",
    "UnprotectWorksheet": "ورقة غير محمية",
    "ReEnterPassword": "أعد إدخال كلمة المرور للمتابعة",
    "SheetPassword": "كلمة مرور لإلغاء حماية الورقة:",
    "ProtectWorkbook": "حماية المصنف",
    "Password": "كلمة المرور (اختياري):",
    "EnterThePassword": "أدخل كلمة المرور",
    "ConfirmPassword": "تأكيد كلمة المرور",
    "EnterTheConfirmPassword": "أعد إدخال كلمة المرور",
    "PasswordAlert": "تأكيد كلمة المرور ليست متطابقة",
    "UnprotectWorkbook": "إلغاء حماية المصنف",
    "UnprotectPasswordAlert": "كلمة المرور التي قدمتها غير صحيحة.",
    "IncorrectPassword": "تعذر فتح الملف أو ورقة العمل بكلمة المرور المقدمة",
    "PasswordAlertMsg": "الرجاء إدخال كلمة المرور",
    "ConfirmPasswordAlertMsg": "الرجاء إدخال تأكيد كلمة المرور",
    "IsProtected": "محمي",
    "PDF": "وثيقة PDF",
    "AutoFillMergeAlertMsg": "للقيام بذلك ، يجب أن تكون جميع الخلايا المدمجة بنفس الحجم.",
    "Fluent": "طلِق",
    "FluentDark": "بطلاقة الظلام",
    "Custom": "العادة",
    "WEEKDAY": "إرجاع يوم الأسبوع المقابل لتاريخ.",
    "FillSeries": "سلسلة التعبئة",
    "CopyCells": "نسخ الخلايا",
    "FillFormattingOnly": "تعبئة التنسيق فقط",
    "FillWithoutFormatting": "املأ بدون تنسيق",
    "CustomFormat": "تنسيقات الأرقام المخصصة",
    "CustomFormatPlaceholder": "اكتب أو حدد تنسيقًا مخصصًا",
    "CustomFormatTypeList": "يكتب",
    "CellReferenceTypoError": "وجدنا خطأ مطبعي في مرجع الخلية الخاصة بك. هل تريد تصحيح هذا المرجع على النحو التالي؟",
    "AddCurrentSelection": "إضافة التحديد الحالي للتصفية",
    "Directional": "اتجاهي",
    "Shapes": "الأشكال",
    "Indicators": "المؤشرات",
    "Ratings": "التقييمات",
    "InvalidFormulaError": "وجدنا أنك كتبت صيغة غير صالحة.",
    "InvalidArguments": "لقد اكتشفنا أنك قمت بكتابة صيغة تحتوي على وسيطات غير صالحة.",
    "EmptyExpression": "لقد وجدنا أنك كتبت صيغة بتعبير فارغ.",
    "MismatchedParenthesis": "لقد اكتشفنا أنك قمت بكتابة صيغة تحتوي على قوس فتح أو إغلاق واحد أو أكثر مفقود.",
    "ImproperFormula": "وجدنا أنك كتبت صيغة غير صحيحة.",
    "WrongNumberOfArguments": "لقد اكتشفنا أنك قمت بكتابة صيغة تحتوي على عدد خاطئ من الوسائط.",
    "Requires3Arguments": "لقد وجدنا أنك كتبت صيغة تتطلب 3 وسائط.",
    "MismatchedStringQuotes": "لقد اكتشفنا أنك كتبت صيغة تحتوي على علامات اقتباس غير متطابقة.",
    "FormulaCircularRef": "لقد وجدنا أنك كتبت صيغة بمرجع دائري."
  },
  "filemanager": {
    "NewFolder": "مجلد جديد",
    "Upload": "رفع",
    "Delete": "حذف",
    "Rename": "إعادة تسمية",
    "Download": "تحميل",
    "Cut": "قطع",
    "Copy": "نسخ",
    "Paste": "لـصق",
    "SortBy": "ترتيب حسب",
    "Refresh": "تحديث",
    "Item-Selection": "العنصر المحدد",
    "Items-Selection": "العناصر المحددة",
    "View": "رأي",
    "Details": "تفاصيل",
    "SelectAll": "اختر الكل",
    "Open": "افتح",
    "Tooltip-NewFolder": "ملف جديد",
    "Tooltip-Upload": "رفع",
    "Tooltip-Delete": "حذف",
    "Tooltip-Rename": "إعادة تسمية",
    "Tooltip-Download": "تحميل",
    "Tooltip-Cut": "قطع",
    "Tooltip-Copy": "نسخ",
    "Tooltip-Paste": "لـصق",
    "Tooltip-SortBy": "ترتيب حسب",
    "Tooltip-Refresh": "تحديث",
    "Tooltip-Selection": "اختيار واضح",
    "Tooltip-View": "رأي",
    "Tooltip-Details": "تفاصيل",
    "Tooltip-SelectAll": "اختر الكل",
    "Name": "اسم",
    "Size": "بحجم",
    "DateModified": "تم التعديل",
    "DateCreated": "تاريخ الإنشاء",
    "Path": "مسار",
    "Modified": "تم التعديل",
    "Created": "أُنشـئت",
    "Location": "موقعك",
    "Type": "اكتب",
    "Permission": "الإذن",
    "Ascending": "تصاعدي",
    "Descending": "تنازلي",
    "None": "لا يوجد",
    "View-LargeIcons": "أيقونات كبيرة",
    "View-Details": "تفاصيل",
    "Search": "بحث",
    "Button-Ok": "حسنا",
    "Button-Cancel": "إلغاء",
    "Button-Yes": "نعم",
    "Button-No": "لا",
    "Button-Create": "إنشــاء",
    "Button-Save": "حفظ",
    "Header-NewFolder": "مجلد",
    "Content-NewFolder": "أدخل اسم المجلد الخاص بك",
    "Header-Rename": "إعادة تسمية",
    "Content-Rename": "أدخل اسمك الجديد",
    "Header-Rename-Confirmation": "إعادة تسمية التأكيد",
    "Content-Rename-Confirmation": "إذا قمت بتغيير ملحق اسم الملف ، فقد يصبح الملف غير مستقر. هل أنت متأكد أنك تريد تغييره؟",
    "Header-Delete": "حذف ملف",
    "Content-Delete": "هل أنت متأكد أنك تريد حذف هذا الملف؟",
    "Header-Folder-Delete": "احذف المجلد",
    "Content-Folder-Delete": "هل أنت متأكد أنك تريد حذف هذا المجلد؟",
    "Header-Multiple-Delete": "حذف ملفات متعددة",
    "Content-Multiple-Delete": "هل أنت متأكد من أنك تريد حذف هذه الملفات {0}؟",
    "Header-Duplicate": "يوجد ملف / مجلد",
    "Content-Duplicate": "{0} موجود بالفعل. هل تريد إعادة تسمية ولصق؟",
    "Header-Upload": "تحميل الملفات",
    "Error": "خطأ",
    "Validation-Empty": "لا يمكن أن يكون اسم الملف أو المجلد فارغًا.",
    "Validation-Invalid": "يحتوي اسم الملف أو المجلد {0} على أحرف غير صالحة. يرجى استخدام اسم مختلف. لا يمكن أن تنتهي أسماء الملفات أو المجلدات الصالحة بنقطة أو مسافة ، ولا يمكن أن تحتوي على أي من الأحرف التالية: \\ /: *؟ \"<> |",
    "Validation-NewFolder-Exists": "يوجد بالفعل ملف أو مجلد يحمل الاسم {0}.",
    "Validation-Rename-Exists": "لا يمكن إعادة تسمية {0} إلى {1}: الوجهة موجودة بالفعل.",
    "Folder-Empty": "هذا المجلد فارغ",
    "File-Upload": "اسحب الملفات هنا للتحميل",
    "Search-Empty": "لم يتم العثور على نتائج",
    "Search-Key": "حاول بكلمات مختلفة",
    "Filter-Empty": "لم يتم العثور على نتائج",
    "Filter-Key": "حاول مع مرشح مختلف",
    "Sub-Folder-Error": "المجلد الوجهة هو المجلد الفرعي للمجلد المصدر.",
    "Same-Folder-Error": "المجلد الوجهة هو نفس المجلد المصدر.",
    "Access-Denied": "تم الرفض",
    "Access-Details": "ليس لديك إذن للوصول إلى هذا المجلد.",
    "Header-Retry": "الملف موجود بالفعل",
    "Content-Retry": "يوجد ملف بهذا الاسم بالفعل في هذا المجلد. ماذا تريد ان تفعل؟",
    "Button-Keep-Both": "احتفظ بكليهما",
    "Button-Replace": "يحل محل",
    "Button-Skip": "تخطى",
    "ApplyAll-Label": "القيام بذلك لجميع العناصر الحالية",
    "KB": "كيلوبايت",
    "Access-Message": "{0} لا يمكن الوصول إليه. تحتاج إلى إذن لتنفيذ الإجراء {1}.",
    "Network-Error": "NetworkError: فشل الإرسال على XMLHTTPRequest: فشل التحميل",
    "Server-Error": "ServerError: استجابة غير صالحة من"
  },
  "calendar": {
    "today": "اليوم"
  },
  "datepicker": {
    "today": "اليوم",
    "placeholder": "اختيار موعد"
  },
  "daterangepicker": {
    "placeholder": "اختيار نطاق التاريخ",
    "startLabel": "تاريخ البدء",
    "endLabel": "تاريخ الانتهاء",
    "applyText": "تطبيق",
    "cancelText": "إلغاء",
    "selectedDays": "أيام مختارة",
    "days": "أيام",
    "customRange": "نطاق مخصص"
  },
  "timepicker": {
    "placeholder": "اختيار الوقت"
  },
  "datetimepicker": {
    "today": "اليوم",
    "placeholder": "اختيار التاريخ والوقت"
  },
  "dialog": {
    "close": "قريب"
  },
  "toast": {
    "close": "قريب"
  },
  "tab": {
    "closeButtonTitle": "قريب"
  },
  "schedule": {
    "day": "يوم",
    "week": "أسبوع",
    "workWeek": "أسبوع العمل",
    "month": "شهر",
    "year": "سنة",
    "agenda": "جدول أعمال",
    "weekAgenda": "الأسبوع جدول الأعمال",
    "workWeekAgenda": "جدول أعمال أسبوع العمل",
    "monthAgenda": "شهر جدول الأعمال",
    "today": "اليوم",
    "noEvents": "لا أحداث",
    "emptyContainer": "لا توجد أحداث مجدولة في هذا اليوم.",
    "allDay": "طوال اليوم",
    "start": "بداية",
    "end": "النهاية",
    "more": "أكثر",
    "close": "قريب",
    "cancel": "إلغاء",
    "noTitle": "(بلا ​​عنوان)",
    "delete": "حذف",
    "deleteEvent": "حذف الحدث",
    "deleteMultipleEvent": "حذف أحداث متعددة",
    "selectedItems": "العناصر المحددة",
    "deleteSeries": "حذف السلسلة",
    "edit": "تصحيح",
    "editSeries": "تحرير السلسلة",
    "editEvent": "تعديل الحدث",
    "createEvent": "إنشــاؤ",
    "subject": "موضوع",
    "addTitle": "أضف عنوانا",
    "moreDetails": "المزيد من التفاصيل",
    "save": "حفظ",
    "editContent": "هل تريد تعديل هذا الحدث أو السلسلة بأكملها فقط؟",
    "deleteContent": "هل أنت متأكد من حذف هذا الحدث؟",
    "deleteMultipleContent": "هل أنت متأكد من أنك تريد حذف الأحداث المختارة؟",
    "newEvent": "حدث جديد",
    "title": "عنوان",
    "location": "موقعك",
    "description": "وصف",
    "timezone": "وحدة زمنية",
    "startTimezone": "بدء المنطقة الزمنية",
    "endTimezone": "نهاية المنطقة الزمنية",
    "repeat": "كرر",
    "saveButton": "حفظ",
    "cancelButton": "إلغاء",
    "deleteButton": "حذف",
    "recurrence": "تكرار",
    "wrongPattern": "نمط التكرار غير صالح.",
    "seriesChangeAlert": "هل تريد إلغاء التغييرات التي تم إجراؤها على مثيلات معينة من هذه السلسلة ومطابقتها مع السلسلة بأكملها مرة أخرى؟",
    "createError": "يجب أن تكون مدة الحدث أقصر من عدد مرات حدوثها. اختصر المدة ، أو غيّر نمط التكرار في محرر حدث التكرار.",
    "sameDayAlert": "لا يمكن أن يحدث تواجد الحدثين في نفس اليوم.",
    "occurenceAlert": "لا يمكن إعادة جدولة تكرار الموعد المتكرر إذا تخطى تكرارًا لاحقًا للموعد نفسه.",
    "editRecurrence": "تحرير تكرار",
    "repeats": "يكرر",
    "alert": "إنذار",
    "startEndError": "ويحدث تاريخ الانتهاء المحدد قبل تاريخ البدء.",
    "invalidDateError": "قيمة التاريخ المدخلة غير صالحة.",
    "blockAlert": "لا يمكن جدولة الأحداث ضمن النطاق الزمني المحظور.",
    "ok": "حسنا",
    "yes": "نعم",
    "no": "لا",
    "occurrence": "حادثة",
    "series": "سلسلة",
    "previous": "السابق",
    "next": "التالى",
    "timelineDay": "يوم المخطط الزمني",
    "timelineWeek": "الأسبوع الزمني للأسبوع",
    "timelineWorkWeek": "الجدول الزمني لأسبوع العمل",
    "timelineMonth": "الجدول الزمني الشهر",
    "timelineYear": "الجدول الزمني العام",
    "editFollowingEvent": "الأحداث التالية",
    "deleteTitle": "حذف الحدث",
    "editTitle": "تحرير الحدث",
    "beginFrom": "تبدأ من",
    "endAt": "يغلق عند مستوى",
    "expandAllDaySection": "قم بتوسيع القسم طوال اليوم",
    "collapseAllDaySection": "طي القسم طوال اليوم",
    "searchTimezone": "البحث عن المنطقة الزمنية",
    "noRecords": "لا توجد سجلات",
    "deleteRecurrenceContent": "هل تريد حذف هذا الحدث فقط أو السلسلة بأكملها؟",
    "recurrenceDateValidation": "بعض الأشهر لديها أقل من التاريخ المحدد. في هذه الأشهر ، سيقع الحدوث في التاريخ الأخير من الشهر."
  },
  "recurrenceeditor": {
    "none": "لا شيء",
    "daily": "اليومي",
    "weekly": "أسبوعي",
    "monthly": "شهريا",
    "month": "شهر",
    "yearly": "سنوي",
    "never": "أبدا",
    "until": "حتى",
    "count": "عد",
    "first": "أول",
    "second": "ثانيا",
    "third": "الثالث",
    "fourth": "رابع",
    "last": "الاخير",
    "repeat": "كرر",
    "repeatEvery": "تكرار كل",
    "on": "كرر",
    "end": "النهاية",
    "onDay": "يوم",
    "days": "يوم",
    "weeks": "أسبوع",
    "months": "الشهور",
    "years": "سنوات",
    "every": "كل",
    "summaryTimes": "مرات",
    "summaryOn": "على",
    "summaryUntil": "حتى",
    "summaryRepeat": "يكرر",
    "summaryDay": "أيام",
    "summaryWeek": "أسابيع",
    "summaryMonth": "الشهور",
    "summaryYear": "سنوات",
    "monthWeek": "شهر اسبوع",
    "monthPosition": "موقف الشهر",
    "monthExpander": "المتوسع الشهر",
    "yearExpander": "المتوسع العام",
    "repeatInterval": "أعد الفترة"
  },
  "gantt": {
    "emptyRecord": "لا سجلات لعرضها",
    "id": "هوية شخصية",
    "name": "اسم",
    "startDate": "تاريخ البدء",
    "endDate": "تاريخ الانتهاء",
    "duration": "المدة الزمنية",
    "progress": "تقدم",
    "dependency": "الاعتماد",
    "notes": "ملاحظات",
    "baselineStartDate": "تاريخ البدء الأساسي",
    "baselineEndDate": "تاريخ نهاية خط الأساس",
    "taskMode": "وضع المهام",
    "changeScheduleMode": "تغيير وضع الجدول",
    "subTasksStartDate": "تاريخ بدء المهام الفرعية",
    "subTasksEndDate": "تاريخ انتهاء المهام الفرعية",
    "scheduleStartDate": "جدولة تاريخ البدء",
    "scheduleEndDate": "تاريخ انتهاء الجدول الزمني",
    "auto": "تلقاءي",
    "manual": "كتيب",
    "type": "اكتب",
    "offset": "عوض",
    "resourceName": "مصادر",
    "resourceID": "معرف المورد",
    "day": "يوم",
    "hour": "ساعة",
    "minute": "دقيقة",
    "days": "أيام",
    "hours": "ساعات",
    "minutes": "الدقائق",
    "generalTab": "جنرال لواء",
    "customTab": "أعمدة مخصصة",
    "writeNotes": "اكتب ملاحظات",
    "addDialogTitle": "مهمة جديدة",
    "editDialogTitle": "معلومات المهمة",
    "saveButton": "حفظ",
    "add": "إضافة",
    "edit": "تعديل",
    "update": "تحديث",
    "delete": "حذف",
    "cancel": "إلغاء",
    "search": "بحث",
    "task": " مهمة",
    "tasks": " مهام",
    "zoomIn": "تكبير",
    "zoomOut": "تصغير",
    "zoomToFit": "تكبير لتناسب",
    "excelExport": "اكسل التصدير",
    "csvExport": "تصدير CSV",
    "expandAll": "توسيع الكل",
    "collapseAll": "انهيار جميع",
    "nextTimeSpan": "الجدول الزمني التالي",
    "prevTimeSpan": "الجدول الزمني السابق",
    "okText": "حسنا",
    "confirmDelete": "هل أنت متأكد أنك تريد حذف السجل؟",
    "from": "من عند",
    "to": "إلى",
    "taskLink": "رابط المهمة",
    "lag": "بطئ",
    "start": "بداية",
    "finish": "إنهاء",
    "enterValue": "أدخل القيمة",
    "taskBeforePredecessor_FS": "قمت بنقل '{0}' للبدء قبل انتهاء '{1}' ويتم ربط المهمتين. ونتيجة لذلك ، لا يمكن احترام الروابط. حدد إجراءً واحدًا أدناه للقيام به",
    "taskAfterPredecessor_FS": "قمت بنقل '{0}' بعيدًا عن '{1}' ويتم ربط المهمتين. ونتيجة لذلك ، لا يمكن احترام الروابط. حدد إجراءً واحدًا أدناه للقيام به",
    "taskBeforePredecessor_SS": "قمت بنقل '{0}' للبدء قبل أن يبدأ '{1}' وربط المهمتين. ونتيجة لذلك ، لا يمكن احترام الروابط. حدد إجراءً واحدًا أدناه للقيام به",
    "taskAfterPredecessor_SS": "قمت بنقل '{0}' للبدء بعد بدء '{1}' وربط المهمتين. ونتيجة لذلك ، لا يمكن احترام الروابط. حدد إجراءً واحدًا أدناه للقيام به",
    "taskBeforePredecessor_FF": "قمت بنقل '{0}' للإنهاء قبل انتهاء '{1}' ويتم ربط المهمتين. ونتيجة لذلك ، لا يمكن احترام الروابط. حدد إجراءً واحدًا أدناه للقيام به",
    "taskAfterPredecessor_FF": "قمت بنقل '{0}' للإنهاء بعد انتهاء '{1}' ويتم ربط المهمتين. ونتيجة لذلك ، لا يمكن احترام الروابط. حدد إجراءً واحدًا أدناه للقيام به",
    "taskBeforePredecessor_SF": "قمت بنقل '{0}' بعيدًا عن '{1}' لبدء التشغيل وترتبط المهمتان. ونتيجة لذلك ، لا يمكن احترام الروابط. حدد إجراءً واحدًا أدناه للقيام به",
    "taskAfterPredecessor_SF": "قمت بنقل '{0}' للإنهاء بعد بدء '{1}' وربط المهمتين. ونتيجة لذلك ، لا يمكن احترام الروابط. حدد إجراءً واحدًا أدناه للقيام به",
    "taskInformation": "معلومات المهمة",
    "deleteTask": "حذف المهمة",
    "deleteDependency": "حذف التبعية",
    "convert": "تحويل",
    "save": "حفظ",
    "above": "في الاعلى",
    "below": "أدناه",
    "child": "طفل",
    "milestone": "معلما",
    "toTask": "لمهمة",
    "toMilestone": "إلى معلم",
    "eventMarkers": "علامات الحدث",
    "leftTaskLabel": "تسمية المهمة اليسرى",
    "rightTaskLabel": "تسمية المهمة الصحيحة",
    "timelineCell": "خلية الجدول الزمني",
    "confirmPredecessorDelete": "هل أنت متأكد أنك تريد إزالة رابط التبعية؟",
    "unit": "وحدة",
    "work": "عمل",
    "taskType": "نوع المهمة",
    "unassignedTask": "مهمة غير محددة",
    "group": "مجموعة",
    "indent": "مسافة بادئة",
    "outdent": "عفا عليها الزمن",
    "segments": "شرائح",
    "splitTask": "تقسيم المهمة",
    "mergeTask": "مهمة الدمج",
    "left": "اليسار",
    "right": "حق"
  },
  "richtexteditor": {
    "alignments": "التحالفات",
    "justifyLeft": "محاذاة إلى اليسار",
    "justifyCenter": "محاذاة مركز",
    "justifyRight": "محاذاة اليمين",
    "justifyFull": "محاذاة الضبط",
    "fontName": "اسم الخط",
    "fontSize": "حجم الخط",
    "fontColor": "لون الخط",
    "backgroundColor": "لون الخلفية",
    "bold": "بالخط العريض",
    "italic": "مائل",
    "underline": "تسطير",
    "strikethrough": "يتوسطه",
    "clearFormat": "تنسيق واضح",
    "clearAll": "امسح الكل",
    "cut": "قطع",
    "copy": "نسخ",
    "paste": "لـصق",
    "unorderedList": "قائمة نقطية",
    "orderedList": "قائمة مرقمة",
    "indent": "زيادة المسافة البادئة",
    "outdent": "انخفاض المسافة البادئة",
    "undo": "الغاء التحميل",
    "redo": "الإعادة",
    "superscript": "حرف فوقي",
    "subscript": "مخطوطة",
    "createLink": "إدراج الارتباط التشعبي",
    "openLink": "افتح الرابط",
    "editLink": "تحرير الرابط",
    "removeLink": "إزالة الرابط",
    "image": "إدراج صورة",
    "replace": "يحل محل",
    "align": "محاذاة",
    "caption": "تعليق على الصورة",
    "remove": "إزالة",
    "insertLink": "إدراج رابط",
    "display": "عرض",
    "altText": "نص بديل",
    "dimension": "قم بتغيير المقاس",
    "fullscreen": "تحقيق أقصى قدر",
    "maximize": "تحقيق أقصى قدر",
    "minimize": "خفض",
    "lowerCase": "أحرف صغيرة",
    "upperCase": "الأحرف الكبيرة",
    "print": "طباعة",
    "formats": "صيغ",
    "sourcecode": "عرض الكود",
    "preview": "معاينة",
    "viewside": "منظر جانبي",
    "insertCode": "أدخل الرمز",
    "linkText": "عرض النص",
    "linkTooltipLabel": "عنوان",
    "linkWebUrl": "عنوان صفحة انترنت",
    "linkTitle": "أدخل العنوان",
    "linkurl": "http://example.com",
    "linkOpenInNewWindow": "افتح الرابط في نافذة جديدة",
    "linkHeader": "إدراج رابط",
    "dialogInsert": "إدراج",
    "dialogCancel": "إلغاء",
    "dialogUpdate": "تحديث",
    "imageHeader": "إدراج صورة",
    "imageLinkHeader": "يمكنك أيضًا تقديم رابط من الويب",
    "mdimageLink": "يرجى تقديم عنوان URL لصورتك",
    "imageUploadMessage": "إسقاط الصورة هنا أو تصفح لتحميل",
    "imageDeviceUploadMessage": "انقر هنا للتحميل",
    "imageAlternateText": "نص بديل",
    "alternateHeader": "نص بديل",
    "browse": "تصفح",
    "imageUrl": "http://example.com/image.png",
    "imageCaption": "التسمية التوضيحية",
    "imageSizeHeader": "حجم الصورة",
    "imageHeight": "ارتفاع",
    "imageWidth": "عرض",
    "textPlaceholder": "أدخل النص",
    "inserttablebtn": "إدراج الجدول",
    "tabledialogHeader": "إدراج الجدول",
    "tableWidth": "عرض",
    "cellpadding": "خلية الحشو",
    "cellspacing": "تباعد الخلايا",
    "columns": "عدد الأعمدة",
    "rows": "عدد الصفوف",
    "tableRows": "صف",
    "tableColumns": "عمود",
    "tableCellHorizontalAlign": "خلية الجدول الأفقي محاذاة",
    "tableCellVerticalAlign": "محاذاة عمودية",
    "createTable": "اصنع جدول",
    "removeTable": "إزالة الجدول",
    "tableHeader": "مقدمة الصف",
    "tableRemove": "يمسح",
    "tableCellBackground": "خلفية خلية الجدول",
    "tableEditProperties": "خصائص تحرير الجدول",
    "styles": "الأنماط",
    "insertColumnLeft": "أدخل العمود الأيسر",
    "insertColumnRight": "أدخل العمود الأيمن",
    "deleteColumn": "حذف العمود",
    "insertRowBefore": "أدخل الصف قبل",
    "insertRowAfter": "أدخل الصف بعد",
    "deleteRow": "احذف صف",
    "tableEditHeader": "تحرير الجدول",
    "TableHeadingText": "عنوان",
    "TableColText": "العقيد",
    "imageInsertLinkHeader": "إدراج رابط",
    "editImageHeader": "تعديل الصورة",
    "alignmentsDropDownLeft": "محاذاة إلى اليسار",
    "alignmentsDropDownCenter": "محاذاة مركز",
    "alignmentsDropDownRight": "محاذاة اليمين",
    "alignmentsDropDownJustify": "محاذاة الضبط",
    "imageDisplayDropDownInline": "في النسق",
    "imageDisplayDropDownBreak": "استراحة",
    "tableInsertRowDropDownBefore": "أدخل الصف قبل",
    "tableInsertRowDropDownAfter": "أدخل الصف بعد",
    "tableInsertRowDropDownDelete": "احذف صف",
    "tableInsertColumnDropDownLeft": "أدخل العمود الأيسر",
    "tableInsertColumnDropDownRight": "أدخل العمود الأيمن",
    "tableInsertColumnDropDownDelete": "حذف العمود",
    "tableVerticalAlignDropDownTop": "محاذاة أعلى",
    "tableVerticalAlignDropDownMiddle": "محاذاة الأوسط",
    "tableVerticalAlignDropDownBottom": "محاذاة أسفل",
    "tableStylesDropDownDashedBorder": "الحدود المتقطع",
    "tableStylesDropDownAlternateRows": "صفوف بديلة",
    "pasteFormat": "تنسيق لصق",
    "pasteFormatContent": "اختر إجراء التنسيق",
    "plainText": "نص عادي",
    "cleanFormat": "نظيف",
    "keepFormat": "احتفظ",
    "pasteDialogOk": "حسنا",
    "pasteDialogCancel": "إلغاء",
    "fileManager": "مدير الملفات",
    "fileDialogHeader": "متصفح الملفات",
    "formatsDropDownParagraph": "فقرة",
    "formatsDropDownCode": "شفرة",
    "formatsDropDownQuotation": "اقتباس",
    "formatsDropDownHeading1": "عنوان 1",
    "formatsDropDownHeading2": "العنوان 2",
    "formatsDropDownHeading3": "العنوان 3",
    "formatsDropDownHeading4": "العنوان 4",
    "fontNameSegoeUI": "SegoeUI",
    "fontNameArial": "اريال",
    "fontNameGeorgia": "جورجيا",
    "fontNameImpact": "تأثير",
    "fontNameTahoma": "تاهوما",
    "fontNameTimesNewRoman": "تايمز نيو رومان",
    "fontNameVerdana": "فيردانا",
    "formatsOLListNumber": "عدد",
    "formatsOLListLowerAlpha": "السفلى ألفا",
    "formatsOLListUpperAlpha": "العلوي",
    "formatsOLListLowerRoman": "LowerRoman",
    "formatsOLListUpperRoman": "أبرومان",
    "formatsOLListLowerGreek": "اليونانية السفلى",
    "formatsULListDisc": "قرص",
    "formatsULListCircle": "دائرة",
    "formatsULListSquare": "ميدان",
    "formatsOLListNone": "لا أحد",
    "formatsULListNone": "لا أحد",
    "formatPainter": "شكل الرسام",
    "emojiPicker": "منتقي الرموز التعبيرية",
    "embeddedCode": "كود مضمن",
    "pasteEmbeddedCodeHere": "الصق التعليمات البرمجية المضمنة هنا",
    "emojiPickerTypeToFind": "اكتب للبحث",
    "emojiPickerNoResultFound": "لم يتم العثور على نتائج",
    "emojiPickerTrySomethingElse": "جرب شيئًا آخر"
  },
  "colorpicker": {
    "Apply": "تطبيق",
    "Cancel": "إلغاء",
    "ModeSwitcher": "تغيير النظام"
  },
  "uploader": {
    "Browse": "تصفح...",
    "Clear": "واضح",
    "Upload": "رفع",
    "dropFilesHint": "أو إسقاط الملفات هنا",
    "invalidMaxFileSize": "حجم الملف كبير جدا",
    "invalidMinFileSize": "حجم الملف صغير جدًا",
    "invalidFileType": "نوع الملف غير مسموح به",
    "uploadFailedMessage": "فشل تحميل الملف",
    "uploadSuccessMessage": "تم رفع الملف بنجاح",
    "removedSuccessMessage": "تمت إزالة الملف بنجاح",
    "removedFailedMessage": "غير قادر على إزالة الملف",
    "inProgress": "تحميل",
    "readyToUploadMessage": "جاهز للتحميل",
    "abort": "إحباط",
    "remove": "إزالة",
    "cancel": "إلغاء",
    "delete": "حذف ملف",
    "pauseUpload": "رفع ملف مؤقتا",
    "pause": "وقفة",
    "resume": "استئنف",
    "retry": "إعادة المحاولة",
    "fileUploadCancel": "تم إلغاء تحميل الملف"
  },
  "numerictextbox": {
    "incrementTitle": "قيمة الزيادة",
    "decrementTitle": "انخفاض القيمة"
  },
  "slider": {
    "incrementTitle": "زيادة",
    "decrementTitle": "تخفيض"
  },
  "formValidator": {
    "required": "هذه الخانة مطلوبه.",
    "email": "رجاء قم بإدخال بريد الكتروني صحيح.",
    "url": "أدخل رابط صحيح من فضلك.",
    "date": "ارجوك ادخل تاريخ صحيح.",
    "dateIso": "الرجاء إدخال تاريخ صالح (ISO).",
    "creditcard": "الرجاء إدخال رقم بطاقة صالح",
    "number": "من فضلك أدخل رقما صالحا.",
    "digits": "الرجاء إدخال الأرقام فقط.",
    "maxLength": "الرجاء إدخال ما لا يزيد عن {0} حرفًا.",
    "minLength": "الرجاء إدخال ما لا يقل عن {0} حرفًا.",
    "rangeLength": "يرجى إدخال قيمة بين {0} و {1} حرفًا.",
    "range": "الرجاء إدخال قيمة بين {0} و {1}.",
    "max": "يرجى إدخال قيمة أقل من أو تساوي {0}.",
    "min": "يرجى إدخال قيمة أكبر من أو تساوي {0}.",
    "regex": "الرجاء إدخال القيمة الصحيحة.",
    "tel": "يرجى إدخال رقم هاتف صالح.",
    "pattern": "الرجاء إدخال قيمة نمط صحيحة.",
    "equalTo": "الرجاء إدخال نص التطابق الصحيح"
  },
  "treegrid": {
    "Above": "في الاعلى",
    "Below": "أدناه",
    "AddRow": "اضف سطر",
    "ExpandAll": "توسيع الكل",
    "CollapseAll": "انهيار جميع"
  },
  "querybuilder": {
    "StartsWith": "ابدا ب",
    "EndsWith": "ينتهي بـ",
    "Contains": "يحتوي على",
    "NotLike": "يتضمن",
    "Like": "لا يشبه",
    "Equal": "يسـاوي",
    "NotEqual": "لا يسـاوي",
    "LessThan": "أقل من",
    "LessThanOrEqual": "اصغر من او يساوي",
    "GreaterThan": "أكثر من",
    "GreaterThanOrEqual": "أكبر من أو يساوي",
    "Between": "ما بين",
    "NotBetween": "ليس بينهما",
    "Empty": "فارغة",
    "NotEmpty": "غير فارغ",
    "In": "في",
    "NotIn": "ليس في",
    "NotContains": "لا يحتوي",
    "Remove": "إزالة",
    "SelectField": "اختر المجال",
    "SelectOperator": "حدد المشغل",
    "DeleteRule": "إزالة هذا الشرط",
    "DeleteGroup": "حذف المجموعة",
    "AddGroup": "إضافة مجموعة",
    "AddCondition": "إضافة شرط",
    "Edit": "تعديل",
    "ValidationMessage": "هذه الخانة مطلوبه",
    "SummaryViewTitle": "عرض ملخص",
    "OtherFields": "مجالات أخرى",
    "AND": "و",
    "OR": "أو",
    "SelectValue": "أدخل القيمة",
    "IsEmpty": "فارغ",
    "IsNotEmpty": "ليس فارغا",
    "IsNull": "باطل",
    "IsNotNull": "هو ليس لاشيء",
    "True": "صحيح",
    "False": "خاطئة"
  },
  "barcode": {},
  "datamatrix": {},
  "qrcode": {},
  "pivotview": {
    "grandTotal": "المبلغ الإجمالي",
    "total": "مجموع",
    "value": "القيمة",
    "noValue": "لا قيمة",
    "row": "صف",
    "column": "عمود",
    "collapse": "انهيار",
    "expand": "وسعت",
    "rowAxisPrompt": "إسقاط الصف هنا",
    "columnAxisPrompt": "إسقاط العمود هنا",
    "valueAxisPrompt": "انخفاض القيمة هنا",
    "filterAxisPrompt": "إسقاط مرشح هنا",
    "filter": "منقي",
    "filtered": "مصفى",
    "sort": "فرز",
    "filters": "مرشحات",
    "rows": "الصفوف",
    "columns": "أعمدة",
    "values": "القيم",
    "close": "قريب",
    "cancel": "إلغاء",
    "delete": "حذف",
    "CalculatedField": "حقل محسوب",
    "createCalculatedField": "إنشاء حقل محسوب",
    "fieldName": "أدخل اسم الحقل",
    "error": "خطأ",
    "invalidFormula": "صيغة غير صالحة.",
    "dropText": "مثال: ('Sum (Order_Count)' + 'Sum (In_Stock)') * 250",
    "dropTextMobile": "إضافة الحقول وتعديل الصيغة هنا.",
    "dropAction": "لا يمكن وضع الحقل المحسوب في أي منطقة أخرى باستثناء محور القيمة.",
    "alert": "إنذار",
    "warning": "تحذير",
    "ok": "حسنا",
    "search": "بحث",
    "drag": "سحب",
    "remove": "إزالة",
    "allFields": "جميع المجالات",
    "formula": "معادلة",
    "addToRow": "أضف إلى الصف",
    "addToColumn": "أضف إلى العمود",
    "addToValue": "أضف إلى القيمة",
    "addToFilter": "إضافة إلى تصفية",
    "emptyData": "لا سجلات لعرضها",
    "fieldExist": "يوجد حقل بالفعل بهذا الاسم. الرجاء إدخال اسم مختلف.",
    "confirmText": "يوجد حقل حساب بالفعل في هذا الاسم. هل تريد استبدالها؟",
    "noMatches": "لا توجد مباريات",
    "format": "ملخصات القيم بواسطة",
    "edit": "تعديل",
    "clear": "واضح",
    "formulaField": "سحب وإسقاط الحقول إلى صيغة",
    "dragField": "اسحب الحقل إلى الصيغة",
    "clearFilter": "واضح",
    "by": "بواسطة",
    "all": "الكل",
    "multipleItems": "عناصر متعددة",
    "member": "عضو",
    "label": "ضع الكلمة المناسبة",
    "date": "تاريخ",
    "enterValue": "أدخل القيمة",
    "chooseDate": "أدخل التاريخ",
    "Before": "قبل",
    "BeforeOrEqualTo": "قبل أو يساوي",
    "After": "بعد",
    "AfterOrEqualTo": "بعد أو يساوي",
    "labelTextContent": "إظهار العناصر التي التسمية",
    "dateTextContent": "عرض العناصر التي التاريخ",
    "valueTextContent": "عرض العناصر التي",
    "Equals": "متساوين",
    "DoesNotEquals": "لا يساوي",
    "BeginWith": "يبدأ ب",
    "DoesNotBeginWith": "لا يبدأ مع",
    "EndsWith": "ينتهي بـ",
    "DoesNotEndsWith": "لا ينتهي ب",
    "Contains": "يحتوي على",
    "DoesNotContains": "لا يحتوي",
    "GreaterThan": "أكثر من",
    "GreaterThanOrEqualTo": "أكبر من أو يساوي",
    "LessThan": "أقل من",
    "LessThanOrEqualTo": "اقل او يساوي",
    "Between": "ما بين",
    "NotBetween": "ليس بينهما",
    "And": "و",
    "Sum": "مجموع",
    "Count": "عد",
    "DistinctCount": "عدد متميز",
    "Product": "المنتج",
    "Avg": "متوسط",
    "Min": "دقيقة",
    "SampleVar": "عينة فار",
    "PopulationVar": "السكان فار",
    "RunningTotals": "تشغيل المجاميع",
    "Max": "ماكس",
    "Index": "فهرس",
    "SampleStDev": "عينة StDev",
    "PopulationStDev": "السكان StDev",
    "PercentageOfRowTotal": "٪ من إجمالي الصف",
    "PercentageOfParentTotal": "٪ من مجموع الأم",
    "PercentageOfParentColumnTotal": "٪ من إجمالي العمود الرئيسي",
    "PercentageOfParentRowTotal": "٪ من إجمالي صف الأصل",
    "DifferenceFrom": "الفرق من",
    "PercentageOfDifferenceFrom": "٪ من الفرق من",
    "PercentageOfGrandTotal": "٪ من المجموع الكلي",
    "PercentageOfColumnTotal": "٪ من إجمالي العمود",
    "NotEquals": "لا يساوي",
    "AllValues": "كل القيم",
    "conditionalFormating": "تنسيق مشروط",
    "apply": "تطبيق",
    "condition": "إضافة شرط",
    "formatLabel": "شكل",
    "valueFieldSettings": "إعدادات حقل القيمة",
    "baseField": "الحقل الأساسي:",
    "baseItem": "العنصر الأساسي:",
    "summarizeValuesBy": "تلخيص القيم بواسطة:",
    "sourceName": "اسم الحقل :",
    "sourceCaption": "عنوان الحقل:",
    "example": "منها مثلا:",
    "editorDataLimitMsg": " المزيد من العناصر. البحث لتحسين صقل.",
    "details": "تفاصيل",
    "manageRecords": "إدارة السجلات",
    "Years": "سنوات",
    "Quarters": "أرباع",
    "Months": "الشهور",
    "Days": "أيام",
    "Hours": "ساعات",
    "Minutes": "الدقائق",
    "Seconds": "ثواني",
    "save": "حفظ تقرير",
    "new": "إنشاء تقرير جديد",
    "load": "حمل",
    "saveAs": "حفظ كتقرير حالي",
    "rename": "إعادة تسمية التقرير الحالي",
    "deleteReport": "حذف تقرير حالي",
    "export": "تصدير",
    "subTotals": "المجاميع الفرعية",
    "grandTotals": "المجاميع الكبرى",
    "reportName": "تقرير اسم :",
    "pdf": "بي دي إف",
    "excel": "تفوق",
    "csv": "CSV",
    "png": "بي إن جي",
    "jpeg": "JPEG",
    "svg": "SVG",
    "mdxQuery": "استعلام MDX",
    "showSubTotals": "عرض المجاميع الفرعية",
    "doNotShowSubTotals": "لا تظهر المجاميع الفرعية",
    "showSubTotalsRowsOnly": "إظهار صفوف الإجماليات الفرعية فقط",
    "showSubTotalsColumnsOnly": "إظهار أعمدة الإجماليات الفرعية فقط",
    "showGrandTotals": "عرض الإجماليات الكبرى",
    "doNotShowGrandTotals": "لا تظهر المجاميع الكبرى",
    "showGrandTotalsRowsOnly": "إظهار صفوف الإجماليات الكبرى فقط",
    "showGrandTotalsColumnsOnly": "إظهار أعمدة الإجماليات الإجمالية فقط",
    "fieldList": "إظهار قائمة الحقول",
    "grid": "عرض الجدول",
    "toolbarFormatting": "تنسيق مشروط",
    "chart": "خريطة",
    "reportMsg": "الرجاء إدخال اسم تقرير vaild!",
    "reportList": "قائمة التقارير",
    "removeConfirm": "هل تريد بالتأكيد حذف هذا التقرير؟",
    "emptyReport": "لا توجد تقارير !!",
    "bar": "شريط",
    "line": "خط",
    "area": "منطقة",
    "scatter": "تبعثر",
    "polar": "قطبي",
    "of": "من",
    "emptyFormat": "لم يتم العثور على تنسيق !!!",
    "emptyInput": "أدخل قيمة",
    "newReportConfirm": "هل تريد حفظ التغييرات للإبلاغ عنها؟",
    "emptyReportName": "أدخل اسم التقرير",
    "qtr": "ربع",
    "null": "لا شيء",
    "undefined": "غير معرف",
    "groupOutOfRange": "خارج النطاق",
    "fieldDropErrorAction": "لا يمكن وضع الحقل الذي تنقله في هذا المجال من التقرير",
    "MoreOption": "أكثر...",
    "aggregate": "مجموع",
    "drillThrough": "حفر من خلال",
    "ascending": "تصاعدي",
    "descending": "تنازلي",
    "number": "رقم",
    "currency": "عملة",
    "percentage": "النسبة المئوية",
    "formatType": "نوع التنسيق",
    "customText": "رمز العملة",
    "symbolPosition": "موقف رمز",
    "left": "اليسار",
    "right": "حق",
    "grouping": "تجمع",
    "true": "صحيح",
    "false": "خاطئة",
    "decimalPlaces": "منازل عشرية",
    "numberFormat": "تنسيق الأرقام",
    "memberType": "نوع الحقل",
    "formatString": "شكل سلسلة",
    "expressionField": "التعبير",
    "customFormat": "أدخل سلسلة التنسيق المخصصة",
    "selectedHierarchy": "التسلسل الهرمي الرئيسي",
    "olapDropText": "مثال: [التدابير]. [كمية الطلب] + ([التدابير]. [كمية الطلب] * 0.10)",
    "Percent": "نسبه مئويه",
    "Custom": "مخصص",
    "Measure": "قياس",
    "Dimension": "البعد",
    "Standard": "اساسي",
    "blank": "(فارغ)",
    "fieldTooltip": "قم بسحب وإسقاط الحقول لإنشاء تعبير. وإذا كنت تريد تحرير الحقول الموجودة المحسوبة! بعد ذلك يمكنك تحقيق ذلك من خلال تحديد الحقل الموجود تحت \"الأعضاء المحتسبون\".",
    "QuarterYear": "ربع السنة",
    "fieldTitle": "اسم الحقل",
    "drillError": "لا يمكن إظهار العناصر الأولية للحقول المحسوبة.",
    "caption": "حقل التسمية التوضيحية",
    "copy": "نسخ",
    "defaultReport": "التقرير الافتراضي",
    "customFormatString": "تنسيق مخصص",
    "invalidFormat": "تنسيق غير صالح.",
    "group": "مجموعة",
    "unGroup": "فك التجميع",
    "invalidSelection": "لا يمكن تجميع هذا الاختيار.",
    "groupName": "أدخل التسمية التوضيحية لعرضها في الرأس",
    "captionName": "أدخل التسمية التوضيحية لحقل المجموعة",
    "selectedItems": "العناصر المختارة",
    "groupFieldCaption": "عنوان الحقل",
    "groupTitle": "أسم المجموعة",
    "startAt": "يبدأ من",
    "endAt": "إنهاء في",
    "groupBy": "الفاصل الزمني من قبل",
    "selectGroup": "حدد المجموعات",
    "numberFormatString": "مثال: C ، P ، 0000٪ ، ### 0. ## 0 # ، إلخ.",
    "stackingcolumn": "عمود مكدس",
    "stackingbar": "شريط مكدس",
    "stackingarea": "منطقة مكدسة",
    "stepline": "خطوة خط",
    "steparea": "منطقة الخطوة",
    "splinearea": "منطقة المفتاح",
    "spline": "خدد",
    "stackingcolumn100": "عمود مكدس بنسبة 100٪",
    "stackingbar100": "شريط مكدس بنسبة 100٪",
    "stackingarea100": "مساحة مكدسة 100٪",
    "bubble": "فقاعة",
    "pareto": "باريتو",
    "radar": "رادار",
    "chartTypeSettings": "إعدادات نوع التخطيط",
    "multipleAxes": "محاور متعددة",
    "sortAscending": "ترتيب تصاعدي",
    "sortDescending": "ترتيب تنازلي",
    "sortNone": "ترتيب ترتيب البيانات",
    "clearCalculatedField": "مسح معلومات الحقل المعدلة",
    "editCalculatedField": "تحرير الحقل المحسوب",
    "ChartType": "نوع التخطيط",
    "yes": "نعم",
    "no": "لا",
    "numberFormatMenu": "تنسيق الأرقام ...",
    "conditionalFormatingMenu": "تنسيق مشروط...",
    "removeCalculatedField": "هل أنت متأكد أنك تريد حذف هذا الحقل المحسوب؟",
    "replaceConfirmBefore": "تقرير مسمى",
    "replaceConfirmAfter": " موجود مسبقا. هل تريد استبدالها؟",
    "pie": "فطيرة",
    "funnel": "قمع",
    "doughnut": "الدونات",
    "pyramid": "هرم",
    "showLegend": "إظهار الأسطورة",
    "exit": "خروج",
    "invalidJSON": "بيانات JSON غير صالحة",
    "invalidCSV": "بيانات CSV غير صالحة",
    "stacked": "مرصوصة",
    "single": "أعزب",
    "multipleAxisMode": "وضع المحاور المتعددة",
    "grandTotalPosition": "وضع المحاور المتعددة",
    "top": "موقف المجاميع الكلية",
    "bottom": "قمة",
    "None": "الأسفل",
    "stackingline": "لا أحد",
    "stackingline100": "خط مكدس",
    "rowPage": "صف بيجر",
    "rowPerPage": "عدد الصفوف في الصفحة",
    "columnPage": "بيجر العمود",
    "columnPerPage": "أعمدة في كل صفحة",
    "goToFirstPage": "اذهب إلى الصفحة الأولى",
    "goToPreviousPage": "الانتقال إلى الصفحة السابقة",
    "goToNextPage": "انتقل إلى الصفحة التالية",
    "goToLastPage": "انتقل إلى الصفحة الأخيرة",
    "combined": "مشترك",
    "subTotalPosition": "موضع المجاميع الفرعية",
    "auto": "تلقاءي"
  },
  "pivotfieldlist": {
    "staticFieldList": "قائمة الحقول المحورية",
    "fieldList": "قائمة الحقول",
    "dropFilterPrompt": "إسقاط مرشح هنا",
    "dropColPrompt": "إسقاط العمود هنا",
    "dropRowPrompt": "إسقاط الصف هنا",
    "dropValPrompt": "انخفاض القيمة هنا",
    "addPrompt": "أضف الحقل هنا",
    "adaptiveFieldHeader": "اختيار المجال",
    "centerHeader": "اسحب الحقول بين المحاور أدناه:",
    "add": "إضافة",
    "drag": "سحب",
    "filter": "منقي",
    "filtered": "مصفى",
    "sort": "فرز",
    "remove": "إزالة",
    "filters": "مرشحات",
    "rows": "الصفوف",
    "columns": "أعمدة",
    "values": "القيم",
    "CalculatedField": "حقل محسوب",
    "createCalculatedField": "إنشاء حقل محسوب",
    "fieldName": "أدخل اسم الحقل",
    "error": "خطأ",
    "invalidFormula": "صيغة غير صالحة.",
    "dropText": "مثال: ('Sum (Order_Count)' + 'Sum (In_Stock)' ') * 250",
    "dropTextMobile": "إضافة الحقول وتعديل الصيغة هنا.",
    "dropAction": "لا يمكن وضع الحقل المحسوب في أي منطقة أخرى باستثناء محور القيمة.",
    "search": "بحث",
    "close": "قريب",
    "cancel": "إلغاء",
    "delete": "حذف",
    "alert": "إنذار",
    "warning": "تحذير",
    "ok": "حسنا",
    "allFields": "جميع المجالات",
    "formula": "معادلة",
    "fieldExist": "يوجد حقل بالفعل بهذا الاسم. الرجاء إدخال اسم مختلف.",
    "confirmText": "يوجد حقل حساب بالفعل في هذا الاسم. هل تريد استبدالها؟",
    "noMatches": "لا توجد مباريات",
    "format": "ملخصات القيم بواسطة",
    "edit": "تعديل",
    "clear": "واضح",
    "formulaField": "سحب وإسقاط الحقول إلى صيغة",
    "dragField": "اسحب الحقل إلى الصيغة",
    "clearFilter": "واضح",
    "by": "بواسطة",
    "enterValue": "أدخل القيمة",
    "chooseDate": "أدخل التاريخ",
    "all": "الكل",
    "multipleItems": "عناصر متعددة",
    "Equals": "متساوين",
    "DoesNotEquals": "لا يساوي",
    "BeginWith": "يبدأ ب",
    "DoesNotBeginWith": "لا يبدأ مع",
    "EndsWith": "ينتهي بـ",
    "DoesNotEndsWith": "لا ينتهي ب",
    "Contains": "يحتوي على",
    "DoesNotContains": "لا يحتوي",
    "GreaterThan": "أكثر من",
    "GreaterThanOrEqualTo": "أكبر من أو يساوي",
    "LessThan": "أقل من",
    "LessThanOrEqualTo": "اقل او يساوي",
    "Between": "ما بين",
    "NotBetween": "ليس بينهما",
    "Before": "قبل",
    "BeforeOrEqualTo": "قبل أو يساوي",
    "After": "بعد",
    "AfterOrEqualTo": "بعد أو يساوي",
    "member": "عضو",
    "label": "ضع الكلمة المناسبة",
    "date": "تاريخ",
    "value": "القيمة",
    "labelTextContent": "إظهار العناصر التي التسمية",
    "dateTextContent": "عرض العناصر التي التاريخ",
    "valueTextContent": "عرض العناصر التي",
    "And": "و",
    "Sum": "مجموع",
    "Count": "عد",
    "DistinctCount": "عدد متميز",
    "Product": "المنتج",
    "Avg": "متوسط",
    "Min": "دقيقة",
    "Max": "ماكس",
    "Index": "فهرس",
    "SampleStDev": "عينة StDev",
    "PopulationStDev": "السكان StDev",
    "SampleVar": "عينة فار",
    "PopulationVar": "السكان فار",
    "RunningTotals": "تشغيل المجاميع",
    "DifferenceFrom": "الفرق من",
    "PercentageOfDifferenceFrom": "٪ من الفرق من",
    "PercentageOfGrandTotal": "٪ من المجموع الكلي",
    "PercentageOfColumnTotal": "٪ من إجمالي العمود",
    "PercentageOfRowTotal": "٪ من إجمالي الصف",
    "PercentageOfParentTotal": "٪ من مجموع الأم",
    "PercentageOfParentColumnTotal": "٪ من إجمالي العمود الرئيسي",
    "PercentageOfParentRowTotal": "٪ من إجمالي صف الأصل",
    "Years": "سنوات",
    "Quarters": "أرباع",
    "Months": "الشهور",
    "Days": "أيام",
    "Hours": "ساعات",
    "Minutes": "الدقائق",
    "Seconds": "ثواني",
    "apply": "تطبيق",
    "valueFieldSettings": "إعدادات حقل القيمة",
    "sourceName": "اسم الحقل :",
    "sourceCaption": "عنوان الحقل:",
    "summarizeValuesBy": "تلخيص القيم بواسطة:",
    "baseField": "الحقل الأساسي:",
    "baseItem": "العنصر الأساسي:",
    "example": "منها مثلا:",
    "editorDataLimitMsg": " المزيد من العناصر. البحث لتحسين صقل.",
    "deferLayoutUpdate": "تأجيل تحديث التصميم",
    "null": "لا شيء",
    "undefined": "غير معرف",
    "groupOutOfRange": "خارج النطاق",
    "fieldDropErrorAction": "لا يمكن وضع الحقل الذي تنقله في هذا المجال من التقرير",
    "MoreOption": "أكثر...",
    "memberType": "نوع الحقل",
    "selectedHierarchy": "التسلسل الهرمي الرئيسي",
    "formatString": "شكل سلسلة",
    "expressionField": "التعبير",
    "olapDropText": "مثال: [التدابير]. [كمية الطلب] + ([التدابير]. [كمية الطلب] * 0.10)",
    "customFormat": "أدخل سلسلة التنسيق المخصصة",
    "Measure": "قياس",
    "Dimension": "البعد",
    "Standard": "اساسي",
    "Currency": "عملة",
    "Percent": "نسبه مئويه",
    "Custom": "مخصص",
    "blank": "(فارغ)",
    "fieldTooltip": "قم بسحب وإسقاط الحقول لإنشاء تعبير. وإذا كنت تريد تحرير الحقول الموجودة المحسوبة! يمكنك تحقيق ذلك من خلال تحديد الحقل ببساطة تحت \"الأعضاء المحتسبون\".",
    "fieldTitle": "اسم الحقل",
    "QuarterYear": "ربع السنة",
    "caption": "حقل التسمية التوضيحية",
    "copy": "نسخ",
    "group": "مجموعة",
    "numberFormatString": "مثال: C ، P ، 0000٪ ، ### 0. ## 0 # ، إلخ.",
    "sortAscending": "ترتيب تصاعدي",
    "sortDescending": "ترتيب تنازلي",
    "sortNone": "ترتيب ترتيب البيانات",
    "clearCalculatedField": "مسح معلومات الحقل المعدلة",
    "editCalculatedField": "تحرير الحقل المحسوب",
    "selectGroup": "حدد المجموعات",
    "of": "من",
    "removeCalculatedField": "هل أنت متأكد أنك تريد حذف هذا الحقل المحسوب؟",
    "yes": "هل أنت متأكد أنك تريد حذف هذا الحقل المحسوب؟",
    "no": "نعم",
    "None": "لا"
  },
  "pdfviewer": {
    "PdfViewer": "قوات الدفاع الشعبي المشاهد",
    "Cancel": "إلغاء",
    "Download file": "تحميل الملف",
    "Download": "تحميل",
    "Enter Password": "هذا المستند محمي بكلمة مرور. الرجاء إدخال كلمة المرور",
    "File Corrupted": "ملف تالف",
    "File Corrupted Content": "الملف تالف ولا يمكن فتحه.",
    "Fit Page": "ملئ الصفحة",
    "Fit Width": "العرض المناسب",
    "Automatic": "تلقائي",
    "Go To First Page": "عرض الصفحة الأولى",
    "Invalid Password": "كلمة سر خاطئة. حاول مرة اخرى.",
    "Next Page": "عرض الصفحة التالية",
    "OK": "حسنا",
    "Open": "فتح الملف",
    "Page Number": "رقم الصفحة الحالية",
    "Previous Page": "عرض الصفحة السابقة",
    "Go To Last Page": "عرض الصفحة الأخيرة",
    "Zoom": "تكبير",
    "Zoom In": "تكبير",
    "Zoom Out": "تصغير",
    "Page Thumbnails": "الصور المصغرة للصفحة",
    "Bookmarks": "إشارات مرجعية",
    "Print": "اطبع الملف",
    "Password Protected": "كلمة المرور مطلوبة",
    "Copy": "نسخ",
    "Text Selection": "أداة اختيار النص",
    "Panning": "وضع عموم",
    "Text Search": "بحث عن نص",
    "Find in document": "البحث في المستند",
    "Match case": "حالة مباراة",
    "Apply": "تطبيق",
    "GoToPage": "انتقل إلى صفحة",
    "No matches": "انتهى العارض من البحث في المستند. لم يتم العثور على المزيد من التطابقات",
    "No Text Found": "لا يوجد نص",
    "Undo": "الغاء التحميل",
    "Redo": "الإعادة",
    "Annotation": "إضافة أو تحرير التعليقات التوضيحية",
    "Highlight": "تسليط الضوء على النص",
    "Underline": "تسطير النص",
    "Strikethrough": "يتوسطه نص",
    "Delete": "حذف التعليق التوضيحي",
    "Opacity": "غموض",
    "Color edit": "غير اللون",
    "Opacity edit": "تغيير العتامة",
    "Highlight context": "تسليط الضوء",
    "Underline context": "تسطير",
    "Strikethrough context": "يتوسطه خط",
    "Server error": "خدمة الويب ليست الاستماع. يعتمد PDF Viewer على خدمة الويب لجميع ميزاته. يرجى بدء خدمة الويب للمتابعة.",
    "Open text": "افتح",
    "First text": "الصفحة الأولى",
    "Previous text": "الصفحة السابقة",
    "Next text": "الصفحة التالية",
    "Last text": "آخر صفحة",
    "Zoom in text": "تكبير",
    "Zoom out text": "تصغير",
    "Selection text": "اختيار",
    "Pan text": "مقلاة",
    "Print text": "طباعة",
    "Search text": "يبحث",
    "Annotation Edit text": "تحرير الشرح",
    "Line Thickness": "سمك الخط",
    "Line Properties": "خصائص الخط",
    "Start Arrow": "ابدأ السهم",
    "End Arrow": "نهاية السهم",
    "Line Style": "أسلوب الخط",
    "Fill Color": "ملء اللون",
    "Line Color": "لون الخط",
    "None": "لا شيء",
    "Open Arrow": "افتح",
    "Closed Arrow": "مغلق",
    "Round Arrow": "مستدير",
    "Square Arrow": "ميدان",
    "Diamond Arrow": "الماس",
    "Butt": "بعقب",
    "Cut": "قطع",
    "Paste": "لـصق",
    "Delete Context": "حذف",
    "Properties": "الخصائص",
    "Add Stamp": "إضافة الطوابع",
    "Add Shapes": "أضف الأشكال",
    "Stroke edit": "تغيير لون السكتة الدماغية",
    "Change thickness": "تغيير سمك الحدود",
    "Add line": "إضافة خط",
    "Add arrow": "أضف سهم",
    "Add rectangle": "أضف مستطيل",
    "Add circle": "إضافة دائرة",
    "Add polygon": "أضف مضلع",
    "Add Comments": "أضف تعليقات",
    "Comments": "تعليقات",
    "No Comments Yet": "لا توجد تعليقات حتى الآن",
    "Accepted": "قبلت",
    "Completed": "منجز",
    "Cancelled": "ألغيت",
    "Rejected": "مرفوض",
    "Leader Length": "طول القائد",
    "Scale Ratio": "نسبة النطاق",
    "Calibrate": "معايرة",
    "Calibrate Distance": "معايرة المسافة",
    "Calibrate Perimeter": "معايرة محيط",
    "Calibrate Area": "معايرة المنطقة",
    "Calibrate Radius": "معايرة نصف القطر",
    "Calibrate Volume": "معايرة الحجم",
    "highlight": "تسليط الضوء",
    "underline": "تسطير",
    "strikethrough": "إضرب من خلال",
    "Seach text": "يبحث",
    "FormDesigner": "إضافة وتحرير حقول النموذج",
    "Client error": "تم العثور على خطأ من جانب العميل. يرجى التحقق من الرؤوس المخصصة المتوفرة في خاصية AjaxRequestSettings وطرق إجراءات الويب في خاصية ServerActionSettings.",
    "FormDesigner Edit text": "إضافة وتحرير حقول النموذج",
    "SubmitForm": "تقديم النموذج",
    "Depth": "عمق",
    "Closed": "مغلق",
    "Round": "مستدير",
    "Square": "ميدان",
    "Diamond": "الماس",
    "Edit": "يحرر",
    "Comment": "تعليق",
    "Comment Panel": "لوحة التعليق",
    "Set Status": "تعيين الحالة",
    "Post": "بريد",
    "Page": "صفحة",
    "Add a comment": "اضف تعليق",
    "Add a reply": "أضف ردًا",
    "Import Annotations": "استيراد التعليقات التوضيحية من ملف جسون",
    "Export Annotations": "تصدير التعليق التوضيحي إلى ملف جسون",
    "Export XFDF": "تصدير التعليق التوضيحي إلى ملف XFDF",
    "Import XFDF": "استيراد التعليقات التوضيحية من ملف XFDF",
    "Add": "يضيف",
    "Clear": "صافي",
    "Bold": "بالخط العريض",
    "Italic": "مائل",
    "Strikethroughs": "يتوسطه خط",
    "Underlines": "تسطير",
    "Superscript": "مرتفع",
    "Subscript": "مخطوطة",
    "Align left": "محاذاة لليسار",
    "Align right": "محاذاة اليمين",
    "Center": "مركز",
    "Justify": "يبرر",
    "Font color": "لون الخط",
    "Text Align": "محاذاة النص",
    "Text Properties": "نوع الخط",
    "SignatureFieldDialogHeaderText": "أضف التوقيع",
    "HandwrittenSignatureDialogHeaderText": "أضف التوقيع",
    "InitialFieldDialogHeaderText": "إضافة الأولي",
    "HandwrittenInitialDialogHeaderText": "إضافة الأولي",
    "Draw Ink": "ارسم الحبر",
    "Create": "إنشــاء",
    "Font family": "خط العائلة",
    "Font size": "حجم الخط",
    "Free Text": "نص مجاني",
    "Import Failed": "نوع ملف جسون أو اسم الملف غير صالح ؛ الرجاء تحديد ملف جسون صالح",
    "File not found": "لم يتم العثور على ملف جسون الذي تم استيراده في الموقع المطلوب",
    "Export Failed": "فشل إجراء تصدير التعليقات التوضيحية ؛ يرجى التأكد من إضافة التعليقات التوضيحية بشكل صحيح",
    "of": "من ",
    "Dynamic": "متحرك",
    "Standard Business": "الأعمال القياسية",
    "Sign Here": "وقع هنا",
    "Custom Stamp": "ختم مخصص",
    "Enter Signature as Name": "أدخل أسمك",
    "Draw-hand Signature": "رسم",
    "Type Signature": "نوع",
    "Upload Signature": "تحميل",
    "Browse Signature Image": "تصفح",
    "Save Signature": "احفظ التوقيع",
    "Save Initial": "حفظ الأولي",
    "Textbox": "مربع الكتابة",
    "Password": "كلمة المرور",
    "Check Box": "خانة اختيار",
    "Radio Button": "زر الراديو",
    "Dropdown": "اسقاط",
    "List Box": "مربع القائمة",
    "Signature": "التوقيع",
    "Delete FormField": "حذف حقل النموذج",
    "Textbox Properties": "خصائص Textbox",
    "Name": "اسم",
    "Tooltip": "تلميح",
    "Value": "قيمة",
    "Form Field Visibility": "رؤية حقل النموذج",
    "Read Only": "يقرأ فقط",
    "Required": "مطلوب",
    "Checked": "التحقق",
    "Show Printing": "عرض الطباعة",
    "Formatting": "شكل",
    "Fill": "يملأ",
    "Border": "حدود",
    "Border Color": "لون الحدود",
    "Thickness": "سماكة",
    "Max Length": "الحد الاقصى للطول",
    "List Item": "اسم العنصر",
    "Export Value": "قيمة البند",
    "Dropdown Item List": "قائمة العناصر المنسدلة",
    "List Box Item List": "قائمة عناصر مربع القائمة",
    "General": "جنرال لواء",
    "Appearance": "مظهر خارجي",
    "Options": "والخيارات",
    "Delete Item": "حذف",
    "Up": "أعلى",
    "Down": "أسفل",
    "Multiline": "متعدد الأسطر",
    "Revised": "مراجعة",
    "Reviewed": "تمت المراجعة",
    "Received": "تلقى",
    "Confidential": "مؤتمن",
    "Approved": "وافق",
    "Not Approved": "غير مقبول",
    "Witness": "شاهد",
    "Initial Here": "المبدئي هنا",
    "Draft": "مسودة",
    "Final": "نهائي",
    "For Public Release": "للنشر العام",
    "Not For Public Release": "ليس للنشر العام",
    "For Comment": "للتعليق",
    "Void": "فارغ",
    "Preliminary Results": "نتائج اولية",
    "Information Only": "المعلومات فقط",
    "in": "في",
    "m": "م",
    "ft_in": "قدم في",
    "ft": "قدم",
    "p": "ص",
    "cm": "سم",
    "mm": "مم",
    "pt": "نقطة",
    "cu": "cu",
    "sq": "قدم مربع",
    "Initial": "مبدئي"
  },
  "diagram": {
    "Copy": "نسخ",
    "Cut": "قطع",
    "Paste": "لـصق",
    "Undo": "الغاء التحميل",
    "Redo": "الإعادة",
    "SelectAll": "اختر الكل",
    "Grouping": "تجمع",
    "Group": "مجموعة",
    "UnGroup": "فك التجميع",
    "Order": "طلب",
    "BringToFront": "اجلب للمقدمة",
    "MoveForward": "تقدم إلى الأمام",
    "SendToBack": "إرسال إلى الخلف",
    "SendBackward": "إرسال إلى الوراء"
  },
  "inplace-editor": {
    "save": "حفظ",
    "cancel": "إلغاء",
    "loadingText": "تحميل...",
    "editIcon": "إضغط للتعديل",
    "editAreaClick": "إضغط للتعديل",
    "editAreaDoubleClick": "اضغط مرتين للتعديل"
  },
  "drawing": {},
  "drop-down-base": {
    "noRecordsTemplate": "لا توجد سجلات",
    "actionFailureTemplate": "فشل الطلب"
  },
  "chart": {
    "Zoom": "تكبير",
    "ZoomIn": "ZoomIn",
    "ZoomOut": "تصغير",
    "Reset": "إعادة تعيين",
    "Pan": "مقلاة",
    "ResetZoom": "إعادة تعيين التكبير"
  },
  "maps": {
    "Zoom": "تكبير",
    "ZoomIn": "ZoomIn",
    "ZoomOut": "تصغير",
    "Reset": "إعادة تعيين",
    "Pan": "مقلاة",
    "ResetZoom": "إعادة تعيين التكبير",
    "ImageNotFound": "الصورة غير موجودة"
  },
  "drop-down-tree": {
    "noRecordsTemplate": "لا توجد سجلات",
    "actionFailureTemplate": "الطلب فشل",
    "overflowCountTemplate": "+ $ {count} أكثر ..",
    "totalCountTemplate": "تم اختيار {عدد} دولار"
  },
  "documenteditor": {
    "Table": "الطاولة",
    "Row": "صف",
    "Cell": "زنزانة",
    "Ok": "حسنا",
    "Cancel": "إلغاء",
    "Size": "بحجم",
    "Preferred Width": "العرض المفضل",
    "Points": "نقاط",
    "Percent": "نسبه مئويه",
    "Measure in": "التدبير في",
    "Alignment": "انتقام",
    "Left": "اليسار",
    "Center": "مركز",
    "Right": "حق",
    "Justify": "برر",
    "Indent from left": "المسافة البادئة من اليسار",
    "Borders and Shading": "الحدود والتظليل",
    "Options": "خيارات",
    "Specify height": "تحديد الارتفاع",
    "At least": "على الأقل",
    "Exactly": "بالضبط",
    "Row height is": "ارتفاع الصف هو",
    "Allow row to break across pages": "السماح للصف بالتقاطع بين الصفحات",
    "Repeat as header row at the top of each page": "كرر كصف رأس في أعلى كل صفحة",
    "Vertical alignment": "انحياز عمودي",
    "Top": "أعلى",
    "Bottom": "الأسفل",
    "Default cell margins": "هوامش الخلية الافتراضية",
    "Default cell spacing": "تباعد الخلايا الافتراضية",
    "Allow spacing between cells": "السماح التباعد بين الخلايا",
    "Cell margins": "هوامش الخلية",
    "Same as the whole table": "نفس الجدول بأكمله",
    "Borders": "الحدود",
    "None": "لا شيء",
    "Style": "أسلوب",
    "Width": "عرض",
    "Height": "ارتفاع",
    "Letter": "رسالة",
    "Tabloid": "صحيفة شعبية",
    "Legal": "قانوني",
    "Statement": "بيان",
    "Executive": "تنفيذي",
    "A3": "A3",
    "A4": "A4",
    "A5": "A5",
    "B4": "ب 4",
    "B5": "B5",
    "Custom Size": "حجم مخصص",
    "Different odd and even": "مختلف وغريب",
    "Different first page": "الصفحة الأولى مختلفة",
    "From edge": "من الحافة",
    "Header": "رأس",
    "Footer": "تذييل",
    "First Page Header": "رأس الصفحة الأولى",
    "First Page Footer": "تذييل الصفحة الأولى",
    "Even Page Header": "حتى رأس الصفحة",
    "Even Page Footer": "زوجي تذييل الصفحة",
    "Odd Page Header": "رأس الصفحة الفردية",
    "Odd Page Footer": "تذييل الصفحة الفردية",
    "Same as Previous": "كالسابق",
    "Section": "قسم",
    "Margin": "هوامش",
    "Paper": "ورقة",
    "Layout": "نسق",
    "Orientation": "اتجاه",
    "Landscape": "المناظر الطبيعيه",
    "Portrait": "صورة",
    "Show page numbers": "عرض أرقام الصفحات",
    "Right align page numbers": "محاذاة أرقام الصفحات الصحيحة",
    "Nothing": "لا شيئ",
    "Tab leader": "زعيم التبويب",
    "Show levels": "عرض المستويات",
    "Use hyperlinks instead of page numbers": "استخدم الارتباطات التشعبية بدلاً من أرقام الصفحات",
    "Build table of contents from": "بناء جدول المحتويات من",
    "Styles": "الأنماط",
    "Available styles": "الأساليب المتاحة",
    "TOC level": "مستوى جدول المحتويات",
    "Heading": "عنوان",
    "Heading 1": "عنوان 1",
    "Heading 2": "العنوان 2",
    "Heading 3": "العنوان 3",
    "Heading 4": "العنوان 4",
    "Heading 5": "العنوان 5",
    "Heading 6": "العنوان 6",
    "List Paragraph": "قائمة الفقرة",
    "Normal": "طبيعي",
    "Outline levels": "مستويات المخطط",
    "Table entry fields": "حقول دخول الجدول",
    "Modify": "تعديل",
    "Color": "اللون",
    "Setting": "ضبط",
    "Box": "صندوق",
    "All": "الكل",
    "Custom": "مخصص",
    "Preview": "معاينة",
    "Shading": "تظليل",
    "Fill": "ملء",
    "Apply To": "تنطبق على",
    "Table Properties": "خصائص الجدول",
    "Cell Options": "خيارات الخلية",
    "Table Options": "خيارات الجدول",
    "Insert Table": "إدراج الجدول",
    "Number of columns": "عدد الأعمدة",
    "Number of rows": "عدد الصفوف",
    "Text to display": "النص للعرض",
    "ScreenTip text": "نص تلميح الشاشة",
    "Address": "عنوان",
    "Insert Hyperlink": "إدراج الارتباط التشعبي",
    "Edit Hyperlink": "تحرير الرابط التشعبي",
    "Insert": "إدراج",
    "General": "جنرال لواء",
    "Indentation": "المسافة الفارغة",
    "Before text": "قبل النص",
    "Special": "مميز",
    "First line": "السطر الأول",
    "Hanging": "شنقا",
    "After text": "بعد النص",
    "By": "بواسطة",
    "Before": "قبل",
    "Line Spacing": "تباعد الأسطر",
    "After": "بعد",
    "At": "في",
    "Multiple": "مضاعف",
    "Spacing": "تباعد",
    "Define new Multilevel list": "تحديد قائمة جديدة متعددة المستويات",
    "List level": "مستوى القائمة",
    "Choose level to modify": "اختيار مستوى لتعديل",
    "Level": "مستوى",
    "Number format": "تنسيق الرقم",
    "Number style for this level": "نمط رقم لهذا المستوى",
    "Enter formatting for number": "أدخل التنسيق للرقم",
    "Start at": "تبدأ في",
    "Restart list after": "إعادة تشغيل القائمة بعد",
    "Position": "موضع",
    "Text indent at": "المسافة البادئة للنص في",
    "Aligned at": "محاذاة في",
    "Follow number with": "اتبع الرقم مع",
    "Tab character": "حرف الجدولة",
    "Space": "الفراغ",
    "Arabic": "عربى",
    "UpRoman": "أبرومان",
    "LowRoman": "LowRoman",
    "UpLetter": "UpLetter",
    "LowLetter": "حرف منخفض",
    "Number": "رقم",
    "Leading zero": "صفر بادئ",
    "Bullet": "رصاصة",
    "Ordinal": "ترتيبي",
    "Ordinal Text": "النص العادي",
    "For East": "من أجل الشرق",
    "No Restart": "لا إعادة التشغيل",
    "Font": "الخط",
    "Font style": "نوع الخط",
    "Underline style": "تسطير الاسلوب",
    "Font color": "لون الخط",
    "Effects": "تأثيرات",
    "Strikethrough": "يتوسطه",
    "Superscript": "حرف فوقي",
    "Subscript": "مخطوطة",
    "Double strikethrough": "يتوسطه خط مزدوج",
    "Regular": "منتظم",
    "Bold": "بالخط العريض",
    "Italic": "مائل",
    "Cut": "قطع",
    "Copy": "نسخ",
    "Paste": "لـصق",
    "Hyperlink": "الارتباط التشعبي",
    "Open Hyperlink": "افتح الرابط التشعبي",
    "Copy Hyperlink": "نسخ الرابط التشعبي",
    "Remove Hyperlink": "إزالة الارتباط التشعبي",
    "Paragraph": "فقرة",
    "Linked Style": "مرتبط (الفقرة والحرف)",
    "Character": "حرف",
    "Merge Cells": "دمج الخلايا",
    "Insert Above": "أدخل أعلاه",
    "Insert Below": "تضاف أدناه",
    "Insert Left": "أدخل اليسار",
    "Insert Right": "أدخل اليمين",
    "Delete": "حذف",
    "Delete Table": "حذف الجدول",
    "Delete Row": "احذف صف",
    "Delete Column": "حذف العمود",
    "File Name": "اسم الملف",
    "Format Type": "نوع التنسيق",
    "Save": "حفظ",
    "Navigation": "التنقل",
    "Results": "النتائج",
    "Replace": "يحل محل",
    "Replace All": "استبدال الكل",
    "We replaced all": "استبدالنا جميع",
    "Find": "تجد",
    "No matches": "لا توجد مباريات",
    "All Done": "كله تمام",
    "Result": "نتيجة",
    "of": "من",
    "instances": "الحالات",
    "with": "مع",
    "Click to follow link": "انقر لمتابعة الرابط",
    "Continue Numbering": "متابعة الترقيم",
    "Bookmark name": "اسم الإشارة المرجعية",
    "Close": "قريب",
    "Restart At": "أعد التشغيل في",
    "Properties": "الخصائص",
    "Name": "اسم",
    "Style type": "نوع النمط",
    "Style based on": "النمط القائم على",
    "Style for following paragraph": "نمط للفقرة التالية",
    "Formatting": "تنسيق",
    "Numbering and Bullets": "الترقيم والرصاص",
    "Numbering": "الترقيم",
    "Update Field": "تحديث الحقل",
    "Edit Field": "تحرير الحقل",
    "Bookmark": "المرجعية",
    "Page Setup": "اعداد الصفحة",
    "No bookmarks found": "لم يتم العثور على إشارات مرجعية",
    "Number format tooltip information": "تنسيق الرقم أحادي المستوى: </br> [PREFIX]٪ [LEVELNUMBER] [SUFFIX] </br> على سبيل المثال ، \"Chapter٪ 1\". سيعرض الترقيم مثل </br> الفصل 1. العنصر </br> الفصل 2. العنصر </br> ... </br> الفصل N. العنصر </br> </br> تنسيق الأرقام متعدد المستويات: </ br> [ PREFIX]٪ [LEVELNUMBER] [SUFFIX] + [PREFIX]٪ [LEVELNUMBER] [SUFFIX] </br> على سبيل المثال ، '٪ 1.٪ 2.' سيعرض الترقيم مثل </br> 1.1. البند </br> 1.2. البند </br> ... </br> 1.N. بند",
    "Format": "شكل",
    "Create New Style": "إنشاء نمط جديد",
    "Modify Style": "تعديل النمط",
    "New": "جديد",
    "Bullets": "الرصاص",
    "Use bookmarks": "استخدام الإشارات المرجعية",
    "Table of Contents": "جدول المحتويات",
    "AutoFit": "احتواء تلقائي",
    "AutoFit to Contents": "الاحتواء التلقائي إلى المحتويات",
    "AutoFit to Window": "الاحتواء التلقائي إلى النافذة",
    "Fixed Column Width": "عرض العمود الثابت",
    "Reset": "إعادة تعيين",
    "Match case": "حالة مباراة",
    "Whole words": "كلمات كاملة",
    "Add": "إضافة",
    "Go To": "اذهب إلى",
    "Search for": "البحث عن",
    "Replace with": "استبدل ب",
    "TOC 1": "جدول المحتويات 1",
    "TOC 2": "جدول المحتويات 2",
    "TOC 3": "جدول المحتويات 3",
    "TOC 4": "جدول المحتويات 4",
    "TOC 5": "جدول المحتويات 5",
    "TOC 6": "جدول المحتويات 6",
    "TOC 7": "جدول المحتويات 7",
    "TOC 8": "جدول المحتويات 8",
    "TOC 9": "جدول المحتويات 9",
    "Right-to-left": "من اليمين الى اليسار",
    "Left-to-right": "من اليسار إلى اليمين",
    "Direction": "اتجاه",
    "Table direction": "اتجاه الجدول",
    "Indent from right": "المسافة البادئة من اليمين",
    "Contextual Spacing": "لا تضيف مسافة بين فقرات نفس الأنماط",
    "Password Mismatch": "كلمة المرور غير متطابقة",
    "Restrict Editing": "تقييد التحرير",
    "Formatting restrictions": "قيود التنسيق",
    "Allow formatting": "السماح بالتنسيق",
    "Editing restrictions": "قيود التحرير",
    "Read only": "يقرأ فقط",
    "Exceptions Optional": "استثناءات (اختياري)",
    "Select Part Of Document And User": "حدد أجزاء من المستند واختر المستخدمين المسموح لهم بتحريرها بحرية.",
    "Everyone": "كل واحد",
    "More users": "المزيد من المستخدمين",
    "Add Users": "إضافة المستخدمين",
    "Enforcing Protection": "نعم ، ابدأ في فرض الحماية",
    "Start Enforcing Protection": "بدء فرض الحماية",
    "Enter User": "أدخل المستخدم",
    "Users": "المستخدمين",
    "Enter new password": "أدخل كلمة مرور جديدة",
    "Reenter new password to confirm": "أعد إدخال كلمة مرور جديدة للتأكيد",
    "Your permissions": "أذوناتك",
    "Protected Document": "هذا المستند محمي من التحرير غير المقصود. يمكنك التعديل في هذه المنطقة.",
    "FormFieldsOnly": "يمكنك فقط ملء النماذج في هذه المنطقة.",
    "CommentsOnly": "يمكنك فقط إدراج التعليقات في هذه المنطقة.",
    "ReadOnlyProtection": "يمكنك التعديل في هذه المنطقة.",
    "Stop Protection": "وقف الحماية",
    "Password": "كلمه السر",
    "Spelling Editor": "محرر هجاء",
    "Spelling": "الإملائية",
    "Spell Check": "التدقيق الإملائي",
    "Underline errors": "تسطير الأخطاء",
    "Ignore": "تجاهل",
    "Ignore All": "تجاهل الكل",
    "Add to Dictionary": "أضف إلى القاموس",
    "Change": "يتغيرون",
    "Change All": "تغير الكل",
    "Suggestions": "اقتراحات",
    "The password is incorrect": "كلمة المرور غير صحيحة",
    "Error in establishing connection with web server": "خطأ في تأسيس اتصال مع خادم الويب",
    "Highlight the regions I can edit": "تسليط الضوء على المناطق التي يمكنني تحريرها",
    "Show All Regions I Can Edit": "إظهار جميع المناطق التي يمكنني تعديلها",
    "Find Next Region I Can Edit": "ابحث عن المنطقة التالية التي يمكنني تعديلها",
    "Keep source formatting": "الاحتفاظ بتنسيق المصدر",
    "Match destination formatting": "تطابق تنسيق الوجهة",
    "Text only": "نص فقط",
    "Comments": "تعليقات",
    "Type your comment": "اكتب تعليقك",
    "Post": "بريد",
    "Reply": "الرد",
    "New Comment": "تعليق جديد",
    "Edit": "تعديل",
    "Resolve": "حل",
    "Reopen": "إعادة فتح",
    "No comments in this document": "لا توجد تعليقات في هذا المستند",
    "more": "أكثر",
    "Type your comment here": "اكتب تعليقك هنا",
    "Next Comment": "التعليق التالي",
    "Previous Comment": "التعليق السابق",
    "Un-posted comments": "التعليقات غير المنشورة",
    "Discard Comment": "التعليقات المضافة لم تنشر. إذا تابعت ، سيتم تجاهل هذا التعليق.",
    "Discard": "ينبذ",
    "No Headings": "لم يتم العثور على عنوان!",
    "Add Headings": "لا تحتوي هذه الوثيقة على عناوين. الرجاء إضافة العناوين والمحاولة مرة أخرى.",
    "More Options": "المزيد من الخيارات",
    "Click to see this comment": "انقر لرؤية هذا التعليق",
    "Drop Down Form Field": "حقل نموذج منسدل",
    "Drop-down items": "عناصر منسدلة",
    "Items in drop-down list": "العناصر في القائمة المنسدلة",
    "ADD": "أضف",
    "REMOVE": "إزالة",
    "Field settings": "الإعدادات الميدانية",
    "Tooltip": "تلميح",
    "Drop-down enabled": "تم تمكين القائمة المنسدلة",
    "Check Box Form Field": "حقل نموذج خانة الاختيار",
    "Check box size": "حجم خانة الاختيار",
    "Auto": "تلقاءي",
    "Default value": "القيمة الافتراضية",
    "Not checked": "غير مدقق",
    "Checked": "التحقق",
    "Check box enabled": "تم تمكين خانة الاختيار",
    "Text Form Field": "حقل نموذج نصي",
    "Type": "نوع",
    "Default text": "النص الافتراضي",
    "Maximum length": "الحد الأقصى لطول",
    "Text format": "تنسيق النص",
    "Fill-in enabled": "تم تمكين التعبئة",
    "Default number": "الرقم الافتراضي",
    "Default date": "التاريخ الافتراضي",
    "Date format": "صيغة التاريخ",
    "Merge Track": "لن يتم وضع علامة على هذا الإجراء على أنه تغيير. هل تريد الاستمرار؟",
    "UnTrack": "لا يمكن تعقبها",
    "Accept": "قبول",
    "Reject": "رفض",
    "Previous Changes": "التغييرات السابقة",
    "Next Changes": "التغييرات القادمة",
    "Inserted": "تم إدراجها",
    "Deleted": "تم الحذف",
    "Changes": "التغييرات",
    "Accept all": "قبول الكل",
    "Reject all": "رفض الكل",
    "No changes": "لا تغيرات",
    "Accept Changes": "قبول التغييرات",
    "Reject Changes": "رفض التغييرات",
    "User": "المستعمل",
    "View": "رأي",
    "Insertion": "إدراج",
    "Deletion": "حذف",
    "All caps": "كل الأحرف الاستهلالية",
    "This region is locked by": "هذه المنطقة مؤمنة من قبل",
    "Lock": "قفل",
    "Unlock": "الغاء القفل",
    "Already locked": "تم تحديد منطقة أو جزء منها مؤمن بالفعل من قبل مستخدم آخر",
    "1, 2, 3, ...": "1 ، 2 ، 3 ، ...",
    "a, b, c, ...": "أ ، ب ، ج ، ...",
    "A, B, C, ...": "أ ، ب ، ج ، ...",
    "I, II, III, ...": "الأول ، الثاني ، الثالث ، ...",
    "i, ii, iii, ...": "الأول ، الثاني ، الثالث ، ...",
    "Text Form": "نموذج نصي",
    "Check Box": "خانة اختيار",
    "DropDown": "اسقاط",
    "Form Fields": "حقول النموذج",
    "Fillin enabled": "تم تمكين التعبئة",
    "Multiple Comment": "الرجاء نشر تعليقك",
    "InsertFootnote": "إدراج",
    "InsertEndnote": "أدخل حاشية",
    "Footnote": "هامش",
    "Endnote": "تعليق ختامي",
    "Click to View/Edit Footnote": "انقر لعرض / تحرير الحاشية السفلية",
    "Click to View/Edit Endnote": "انقر لعرض / تحرير التعليق الختامي",
    "InsertAsRows": "إدراج كصفوف جديدة",
    "InsertAsColumns": "إدراج كأعمدة جديدة",
    "OverwriteCells": "الكتابة فوق الخلايا",
    "NestTable": "عش الجدول",
    "No suggestions": "بدون اقتراحات",
    "More Suggestion": "المزيد من الاقتراحات",
    "Ignore Once": "تجاهل مرة واحدة",
    "Keep With Next": "استمر مع التالي",
    "Keep Lines Together": "حافظ على الخطوط معًا",
    "WidowControl": "التحكم بالأسطر الناقصة / اليتيم",
    "Indents and Spacing": "اللمسافات البادئة والتباعد",
    "Line and Page Breaks": "فواصل الأسطر والصفحات",
    "Pagination": "ترقيم الصفحات",
    "Single": "غير مرتبطة",
    "DashSmallGap": "داشسمول جاب",
    "DashDot": "داش دوت",
    "Double": "مزدوج",
    "ThinThickSmallGap": "ThinThickSmallGap",
    "ThickThinSmallGap": "ThickThinSmallGap",
    "ThickThinMediumGap": "ThickThinMediumGap",
    "ThickThinLargeGap": "ThickThinLargeGap",
    "SingleWavy": "واحد مموج",
    "DoubleWavy": "دبل ويفي",
    "Inset": "أقحم",
    "DashLargeGap": "DashLargeGap",
    "Dot": "نقطة",
    "DashDotDot": "DashDotDot",
    "Triple": "ثلاثية",
    "ThinThickThinSmallGap": "ThinThickThinSmallGap",
    "ThinThickThinMediumGap": "ThinThickThinMediumGap",
    "ThinThickThinLargeGap": "ThinThickThinLargeGap",
    "DashDotStroked": "DashDotStroked",
    "Engrave3D": "نقش ثلاثي الأبعاد",
    "Thick": "سميك",
    "Outset": "البداية",
    "Emboss3D": "النقش",
    "ThinThickLargeGap": "ThinThickLargeGap",
    "ThinThickMediumGap": "ThinThickMediumGap",
    "Number of rows must be between": "يجب أن يكون عدد الصفوف بين",
    "Number of columns must be between": "يجب أن يكون عدد الأعمدة بين",
    "and": "و",
    "Unlimited": "غير محدود",
    "Regular text": "نص عادي",
    "Date": "تاريخ",
    "Uppercase": "الأحرف الكبيرة",
    "Lowercase": "أحرف صغيرة",
    "FirstCapital": "فيرست كابيتال",
    "TitleCase": "حالة العنوان",
    "Filling in forms": "تعبئة النماذج",
    "px": "مقصف",
    "Tracked changes": "التغييرات المتعقبة",
    "TrackChangesOnly": "يمكنك التعديل في هذه المنطقة ، ولكن سيتم تعقب كل التغييرات",
    "RemovedIgnore": "هل تريد إزالة الاستثناءات التي تم تجاهلها؟",
    "RemovedIgnoreExceptions": "إذا أجريت هذا التغيير في حماية المستند ، فسيتجاهل Word كافة الاستثناءات في هذا المستند",
    "Information": "معلومة",
    "Yes": "نعم",
    "No": "رقم",
    "Page Break": "فاصل صفحة",
    "Column Break": "فاصل العمود",
    "Section Break Next Page": "فاصل مقطعي (الصفحة التالية) ",
    "Section Break Continuous": "فاصل مقطعي (مستمر)",
    "Unsupported format": "تنسيق الملف الذي حددته غير مدعوم. الرجاء اختيار تنسيق صالح.",
    "One": "واحد",
    "Two": "اثنين",
    "Three": "ثلاثة",
    "Presets": "الإعدادات المسبقة",
    "Columns": "الأعمدة",
    "Split your text into two or more columns": "قسّم النص إلى عمودين أو أكثر",
    "Line between column": "خط بين العمود",
    "Width and Spacing": "العرض والتباعد",
    "Equal column width": "عرض عمود متساوي",
    "Column": "عمود",
    "Paste Content Dialog": "نظرًا لسياسة أمان المتصفح ، يتم تقييد اللصق من محفظة النظام. بدلاً من ذلك ، استخدم اختصار لوحة المفاتيح",
    "Paste CheckBox Content Dialog": "لا تظهر مرة أخرى",
    "The top/bottom margins are too large for the page height in some sections.": "الهوامش العلوية / السفلية كبيرة جدًا بالنسبة لارتفاع الصفحة في بعض الأقسام.",
    "Column width cannot be less than 36 pt.": "لا يمكن أن يكون عرض العمود أقل من 36 نقطة.",
    "Left and right margins.": "الإعدادات التي اخترتها للهوامش اليمنى واليسرى، أو تباعد الأعمدة، أو المسافات البادئة للرسم البياني كبيرة جدًا بالنسبة لعرض الصفحة في نفس الأقسام.",
    "The address of this site is not valid. Check the address and try again.": "عنوان هذا الموقع غير صالح. ",
    "Alt Text": "نص بديل",
    "Title": "عنوان",
    "Description": "وصف",
    "Left and right margins": "الإعدادات التي اخترتها للهوامش اليمنى واليسرى، أو تباعد الأعمدة، أو المسافات البادئة للرسم البياني كبيرة جدًا بالنسبة لعرض الصفحة في نفس الأقسام.",
    "Number of rows must be between 1 and 32767.": "يجب أن يكون عدد الصفوف بين 1 و32767.",
    "Number of columns must be between 1 and 63.": "يجب أن يتراوح عدد الأعمدة بين 1 و63.",
    "You may format text only with certain styles": "لا يجوز لك تنسيق النص إلا باستخدام أنماط معينة."
  },
  "documenteditorcontainer": {
    "New": "جديد",
    "Open": "افتح",
    "Undo": "الغاء التحميل",
    "Redo": "الإعادة",
    "Image": "صورة",
    "Table": "الطاولة",
    "Link": "حلقة الوصل",
    "Bookmark": "المرجعية",
    "Table of Contents": "جدول المحتويات",
    "HEADING - - - - 1": "عنوان 1",
    "HEADING - - - - 2": "العنوان - - - - 2",
    "HEADING - - - - 3": "العنوان - - - - 3",
    "Header": "رأس",
    "Footer": "تذييل",
    "Page Setup": "اعداد الصفحة",
    "Page Number": "رقم الصفحة",
    "Break": "استراحة",
    "Find": "تجد",
    "Local Clipboard": "المحفظة المحلية",
    "Restrict Editing": "تقييد التحرير",
    "Upload from computer": "رفع الملف من الحاسوب",
    "By URL": "بواسطة URL",
    "Page Break": "فاصل صفحة",
    "Section Break": "فاصل المقطع",
    "Header And Footer": "تذييل الرأس",
    "Options": "خيارات",
    "Levels": "مستويات",
    "Different First Page": "الصفحة الأولى مختلفة",
    "Different header and footer for odd and even pages": "رأس وتذييل مختلف للصفحات الفردية والزوجية.",
    "Different Odd And Even Pages": "الصفحات الفردية والزوجية المختلفة",
    "Different header and footer for first page": "رأس وتذييل مختلف للصفحة الأولى.",
    "Position": "موضع",
    "Header from Top": "رأس من الأعلى",
    "Footer from Bottom": "تذييل من أسفل",
    "Distance from top of the page to top of the header": "المسافة من أعلى الصفحة إلى أعلى الرأس.",
    "Distance from bottom of the page to bottom of the footer": "المسافة من أسفل الصفحة إلى أسفل التذييل.",
    "Aspect ratio": "ابعاد متزنة",
    "W": "دبليو",
    "H": "ح",
    "Width": "عرض",
    "Height": "ارتفاع",
    "Text": "نص",
    "Paragraph": "فقرة",
    "Fill": "ملء",
    "Fill color": "ملء اللون",
    "Border Style": "نمط الحدود",
    "Outside borders": "الحدود الخارجية",
    "All borders": "كل الحدود",
    "Inside borders": "داخل الحدود",
    "Left border": "الحدود اليسرى",
    "Inside vertical border": "داخل الحدود العمودية",
    "Right border": "الحدود اليمنى",
    "Top border": "الحدود العليا",
    "Inside horizontal border": "داخل الحدود الأفقية",
    "Bottom border": "الحد السفلي",
    "Border color": "لون الحدود",
    "Border width": "عرض الحدود",
    "Cell": "زنزانة",
    "Merge cells": "دمج الخلايا",
    "Insert Or Delete": "إدراج / حذف",
    "Insert columns to the left": "أدخل الأعمدة إلى اليسار",
    "Insert columns to the right": "أدخل الأعمدة على اليمين",
    "Insert rows above": "إدراج الصفوف أعلاه",
    "Insert rows below": "إدراج الصفوف أدناه",
    "Delete rows": "حذف الصفوف",
    "Delete columns": "حذف الأعمدة",
    "Cell Margin": "هامش الخلية",
    "Top": "أعلى",
    "Bottom": "الأسفل",
    "Left": "اليسار",
    "Right": "حق",
    "Align Text": "محاذاة النص",
    "Align top": "محاذاة أعلى",
    "Align bottom": "محاذاة القاع",
    "Align center": "محاذاة المركز",
    "Number of heading or outline levels to be shown in table of contents": "عدد مستويات العنوان أو المخطط التفصيلي الموضح في جدول المحتويات.",
    "Show page numbers": "عرض أرقام الصفحات",
    "Show page numbers in table of contents": "إظهار أرقام الصفحات في جدول المحتويات.",
    "Right align page numbers": "محاذاة أرقام الصفحات الصحيحة",
    "Right align page numbers in table of contents": "محاذاة أرقام الصفحات في جدول المحتويات.",
    "Use hyperlinks": "استخدام الارتباطات التشعبية",
    "Use hyperlinks instead of page numbers": "استخدم الارتباطات التشعبية بدلاً من أرقام الصفحات.",
    "Font": "الخط",
    "Font Size": "حجم الخط",
    "Font color": "لون الخط",
    "Text highlight color": "لون تسليط الضوء على النص",
    "Clear all formatting": "امسح كل التنسيقات",
    "Bold Tooltip": "غامق (Ctrl + B)",
    "Italic Tooltip": "مائل (Ctrl + I)",
    "Underline Tooltip": "تسطير (Ctrl + U)",
    "Strikethrough": "يتوسطه",
    "Superscript Tooltip": "مرتفع (Ctrl + Shift ++)",
    "Subscript Tooltip": "منخفض (Ctrl + =)",
    "Align left Tooltip": "محاذاة إلى اليسار (Ctrl + L)",
    "Center Tooltip": "المركز (Ctrl + E)",
    "Align right Tooltip": "محاذاة لليمين (Ctrl + R)",
    "Justify Tooltip": "الضبط (Ctrl + J)",
    "Decrease indent": "انخفاض المسافة البادئة",
    "Increase indent": "زيادة المسافة البادئة",
    "Line spacing": "تباعد الأسطر",
    "Bullets": "الرصاص",
    "Numbering": "الترقيم",
    "Styles": "الأنماط",
    "Manage Styles": "إدارة الأنماط",
    "Page": "صفحة",
    "of": "من",
    "Fit one page": "تناسب صفحة واحدة",
    "Spell Check": "التدقيق الإملائي",
    "Underline errors": "تسطير الأخطاء",
    "Fit page width": "تناسب عرض الصفحة",
    "Update": "تحديث",
    "Cancel": "إلغاء",
    "Insert": "إدراج",
    "No Border": "ليس لها حدود",
    "Create a new document": "قم بإنشاء مستند جديد.",
    "Open a document": "افتح المستند.",
    "Undo Tooltip": "التراجع عن العملية الأخيرة (Ctrl + Z).",
    "Redo Tooltip": "أعد العملية الأخيرة (Ctrl + Y).",
    "Insert inline picture from a file": "إدراج صورة مضمنة من ملف.",
    "Insert a table into the document": "إدراج جدول في المستند",
    "Create Hyperlink": "قم بإنشاء رابط في وثيقتك للوصول السريع إلى صفحات الويب والملفات (Ctrl + K).",
    "Insert a bookmark in a specific place in this document": "إدراج إشارة مرجعية في مكان محدد في هذا المستند.",
    "Provide an overview of your document by adding a table of contents": "قدّم نظرة عامة على المستند عن طريق إضافة جدول محتويات.",
    "Add or edit the header": "إضافة أو تحرير الرأس.",
    "Add or edit the footer": "إضافة أو تحرير تذييل الصفحة.",
    "Open the page setup dialog": "افتح مربع حوار إعداد الصفحة.",
    "Add page numbers": "إضافة أرقام الصفحات.",
    "Find Text": "ابحث عن نص في المستند (Ctrl + F).",
    "Toggle between the internal clipboard and system clipboard": "التبديل بين المحفظة الداخلية ومحفظة النظام. </ b> تم رفض الوصول إلى محفظة النظام من خلال البرنامج النصي بسبب سياسة أمان المتصفحات. بدلاً من ذلك ، </br> 1. يمكنك تمكين المحفظة الداخلية من القص والنسخ واللصق داخل المكون. </ b> 2. يمكنك استخدام اختصارات لوحة المفاتيح (Ctrl + X و Ctrl + C و Ctrl + V) للقص ونسخ ولصق مع محفظة النظام.",
    "Current Page Number": "رقم الصفحة الحالية في المستند. انقر أو اضغط للتنقل في صفحة معينة.",
    "Read only": "يقرأ فقط",
    "Protections": "الحماية",
    "Error in establishing connection with web server": "خطأ في تأسيس اتصال مع خادم الويب",
    "Single": "غير مرتبطة",
    "Double": "مزدوج",
    "New comment": "تعليق جديد",
    "Comments": "تعليقات",
    "Print layout": "تخطيط الطباعة",
    "Web layout": "تخطيط ويب",
    "Text Form": "نموذج نصي",
    "Check Box": "خانة اختيار",
    "DropDown": "اسقاط",
    "Update Fields": "تحديث الحقول",
    "Update cross reference fields": "تحديث حقول الإسناد الترافقي",
    "Hide properties pane": "إخفاء جزء الخصائص",
    "Show properties pane": "إظهار جزء الخصائص",
    "Form Fields": "حقول النموذج",
    "Track Changes": "تتبع التغييرات التي تم إجراؤها في المستند",
    "TrackChanges": "تعقب التغيرات",
    "AllCaps": "AllCaps",
    "Change case Tooltip": "تغيير الحالة",
    "Insert Footnote": "أدخل حاشية سفلية",
    "Insert Endnote": "أدخل تعليق ختامي",
    "Footnote Tooltip": "أدخل حاشية سفلية (Alt + Ctrl + F).",
    "Endnote Tooltip": "قم بإدراج تعليق ختامي (Alt + Ctrl + D).",
    "UPPERCASE": "الأحرف الكبيرة",
    "No color": "لا لون",
    "Top margin": "الهامش العلوي",
    "Bottom margin": "الهامش السفلي",
    "Left margin": "الهامش الأيسر",
    "Right margin": "الهامش الأيمن",
    "Normal": "طبيعي",
    "Heading": "عنوان",
    "Heading 1": "عنوان 1",
    "Heading 2": "العنوان 2",
    "Heading 3": "العنوان 3",
    "Heading 4": "العنوان 4",
    "Heading 5": "العنوان 5",
    "Heading 6": "العنوان 6",
    "ZoomLevelTooltip": "مستوى التكبير. انقر أو اضغط لفتح خيارات التكبير.",
    "None": "لا أحد",
    "Borders": "الحدود",
    "ShowHiddenMarks Tooltip": "إظهار الأحرف المخفية مثل المسافات وعلامات الجدولة وعلامات الفقرات والفواصل. (Ctrl + *)",
    "Columns": "الأعمدة",
    "Column Break": "فاصل العمود",
    "Alternate Text": "نص بديل",
    "The address of this site is not valid. Check the address and try again.": "عنوان هذا الموقع غير صالح. ",
    "OK": "نعم",
    "Information": "معلومة"
  },
  "carousel": {
    "nextSlide": "الشريحة التالية",
    "of": "من",
    "pauseSlideTransition": "وقفة انتقال الشريحة",
    "playSlideTransition": "لعب انتقال الشريحة",
    "previousSlide": "الشريحة السابقة",
    "slide": "الانزلاق",
    "slideShow": "عرض الشرائح"
  },
  "message": {
    "close": "قريب"
  },
  "image-editor": {
    "0": "0%",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "20": "20%",
    "40": "40%",
    "60": "60%",
    "80": "80%",
    "100": "100%",
    "Crop": "اقتصاص",
    "CropAndTransform": "المحاصيل والتحويل",
    "ZoomIn": "تكبير",
    "ZoomOut": "تصغير",
    "Undo": "الغاء التحميل",
    "Redo": "إعادة",
    "Transform": "تحول",
    "Annotation": "حاشية. ملاحظة",
    "Finetune": "ضبط دقيق",
    "Brightness": "سطوع",
    "Contrast": "مقابلة",
    "Hue": "مسحة",
    "Saturation": "التشبع",
    "Opacity": "العتامة",
    "Blur": "طمس",
    "Sharpen": "شحذ",
    "Exposure": "التعرض",
    "Filter": "منقي",
    "Default": "تقصير",
    "Chrome": "كروم",
    "Cold": "بارد",
    "Warm": "دافيء",
    "Grayscale": "تدرج الرمادي",
    "BlackAndWhite": "اسود و ابيض",
    "Sepia": "بني داكن",
    "Invert": "عكس",
    "Text": "إضافة نص",
    "Pen": "قلم",
    "Reset": "إعادة ضبط",
    "Save": "يحفظ",
    "Select": "يختار",
    "RotateLeft": "استدر يسارا",
    "RotateRight": "تدوير لليمين",
    "HorizontalFlip": "الوجه الأفقي",
    "VerticalFlip": "الوجه العمودي",
    "OK": "نعم",
    "Cancel": "يلغي",
    "FillColor": "لون التعبئة",
    "StrokeColor": "حلقه ملونه",
    "StrokeWidth": "عرض السكتة الدماغية",
    "FontFamily": "خط العائلة",
    "FontStyle": "نوع الخط",
    "FontSize": "حجم الخط",
    "FontColor": "لون الخط",
    "Pan": "مِقلاة",
    "Move": "يتحرك",
    "Load": "حمولة",
    "Custom": "مخصص",
    "Square": "مربع",
    "Circle": "دائرة",
    "Ellipse": "الشكل البيضاوي",
    "Rectangle": "مستطيل",
    "Line": "خط",
    "Arrow": "سهم",
    "Path": "طريق",
    "Bold": "عريض",
    "Italic": "مائل",
    "BoldItalic": "مائل غامق",
    "XSmall": "صغير جدًا",
    "Small": "صغير",
    "Medium": "واسطة",
    "Large": "كبير",
    "XLarge": "X-كبير",
    "ABC": "اي بي سي",
    "Browse": "تصفح",
    "Duplicate": "ينسخ",
    "Remove": "يزيل",
    "EditText": "تحرير النص",
    "Start": "يبدأ",
    "End": "نهاية",
    "Bar": "حاجِز",
    "ArrowSolid": "السهم صلب",
    "CircleSolid": "دائرة صلبة",
    "SquareSolid": "الصلبة مربعة",
    "None": "لا أحد",
    "CropSelection": "اختيار المحاصيل",
    "Image": "إضافة صورة",
    "Transparency": "الشفافية",
    "Height": "ارتفاع",
    "Width": "عرض",
    "AspectRatio": "الحفاظ على نسبة العرض إلى الارتفاع",
    "W": "دبليو",
    "H": "ح",
    "DragText": "قم بسحب وإسقاط صورتك هنا أو",
    "BrowseText": "تصفح هنا...",
    "SupportText": "يدعم:",
    "Frame": "إطار",
    "Mat": "حصيرة",
    "Bevel": "شطبة",
    "Inset": "أقحم",
    "Hook": "خطاف",
    "Color": "لون",
    "Size": "مقاس",
    "Offset": "عوض",
    "Radius": "نصف القطر",
    "Amount": "كمية",
    "Resize": "تغيير الحجم",
    "Border": "حدود",
    "Solid": "صلب",
    "Dashed": "متقطع",
    "Dotted": "منقط",
    "GradientColor": "التدرج اللوني",
    "ConfirmDialogHeader": "تأكيد حفظ التغييرات",
    "ConfirmDialogContent": "هل تريد حفظ التغييرات التي أجريتها على الصورة؟",
    "AlertDialogHeader": "ملف غير مدعم",
    "AlertDialogContent": "الملف المسقط غير مدعوم.",
    "Yes": "نعم",
    "No": "لا",
    "DropText": "قم بإسقاط صورتك هنا أو"
  },
  "mention": {
    "noRecordsTemplate": "لا توجد سجلات"
  },
  "inplaceeditor": {
    "save": "يحفظ",
    "cancel": "يلغي",
    "loadingText": "تحميل...",
    "editIcon": "إضغط للتعديل",
    "editAreaClick": "إضغط للتعديل",
    "editAreaDoubleClick": "اضغط مرتين للتعديل"
  },
  "PdfViewer": {
    "PdfViewer": "عارض قوات الدفاع الشعبي",
    "Cancel": "يلغي",
    "Download file": "تحميل الملف",
    "Download": "تحميل",
    "Enter Password": "هذه الوثيقة محمية بكلمة مرور. ",
    "File Corrupted": "ملف تالف",
    "File Corrupted Content": "الملف تالف ولا يمكن فتحه.",
    "Fit Page": "ملئ الصفحة",
    "Fit Width": "العرض المناسب",
    "Automatic": "تلقائي",
    "Go To First Page": "عرض الصفحة الأولى",
    "Invalid Password": "كلمة سر خاطئة. ",
    "Next Page": "عرض الصفحة التالية",
    "OK": "نعم",
    "Open": "افتح الملف",
    "Page Number": "رقم الصفحة الحالية",
    "Previous Page": "إظهار الصفحة السابقة",
    "Go To Last Page": "إظهار الصفحة الأخيرة",
    "Zoom": "تكبير",
    "Zoom In": "تكبير",
    "Zoom Out": "تصغير",
    "Page Thumbnails": "الصور المصغرة للصفحة",
    "Bookmarks": "إشارات مرجعية",
    "Print": "اطبع الملف",
    "Password Protected": "كلمة المرور مطلوبة",
    "Copy": "ينسخ",
    "Text Selection": "أداة اختيار النص",
    "Panning": "وضع عموم",
    "Text Search": "بحث عن نص",
    "Find in document": "البحث في الوثيقة",
    "Match case": "حالة مباراة",
    "Apply": "يتقدم",
    "GoToPage": "انتقل إلى صفحة",
    "No matches": "لقد انتهى العارض من البحث في المستند. ",
    "No Text Found": "لم يتم العثور على نص",
    "Undo": "الغاء التحميل",
    "Redo": "إعادة",
    "Annotation": "إضافة أو تحرير التعليقات التوضيحية",
    "Highlight": "تسليط الضوء على النص",
    "Underline": "تسطير النص",
    "Strikethrough": "نص يتوسطه خط",
    "Delete": "حذف التعليق التوضيحي",
    "Opacity": "العتامة",
    "Color edit": "غير اللون",
    "Opacity edit": "تغيير التعتيم",
    "Highlight context": "تسليط الضوء",
    "Underline context": "تسطير",
    "Strikethrough context": "اضرب من خلال",
    "Server error": "خدمة الويب لا تستمع. ",
    "Open text": "يفتح",
    "First text": "الصفحة الأولى",
    "Previous text": "الصفحة السابقة",
    "Next text": "الصفحة التالية",
    "Last text": "آخر صفحة",
    "Zoom in text": "تكبير",
    "Zoom out text": "تصغير",
    "Selection text": "اختيار",
    "Pan text": "مِقلاة",
    "Print text": "مطبعة",
    "Search text": "يبحث",
    "Annotation Edit text": "تحرير التعليق التوضيحي",
    "Line Thickness": "سمك الخط",
    "Line Properties": "خصائص الخط",
    "Start Arrow": "ابدأ السهم",
    "End Arrow": "سهم النهاية",
    "Line Style": "أسلوب الخط",
    "Fill Color": "لون التعبئة",
    "Line Color": "لون الخط",
    "None": "لا أحد",
    "Open Arrow": "يفتح",
    "Closed Arrow": "مغلق",
    "Round Arrow": "دائري",
    "Square Arrow": "مربع",
    "Diamond Arrow": "الماس",
    "Butt": "بعقب",
    "Cut": "قطع",
    "Paste": "لـصق",
    "Delete Context": "يمسح",
    "Properties": "ملكيات",
    "Add Stamp": "أضف ختم",
    "Add Shapes": "إضافة الأشكال",
    "Stroke edit": "تغيير لون السكتة الدماغية",
    "Change thickness": "تغيير سمك الحدود",
    "Add line": "إضافة خط",
    "Add arrow": "إضافة سهم",
    "Add rectangle": "إضافة مستطيل",
    "Add circle": "أضف دائرة",
    "Add polygon": "إضافة مضلع",
    "Add Comments": "أضف تعليقات",
    "Comments": "تعليقات",
    "No Comments Yet": "لا تعليقات حتى الآن",
    "Accepted": "قبلت",
    "Completed": "مكتمل",
    "Cancelled": "ألغيت",
    "Rejected": "مرفوض",
    "Leader Length": "طول القائد",
    "Scale Ratio": "نسبة النطاق",
    "Calibrate": "معايرة",
    "Calibrate Distance": "معايرة المسافة",
    "Calibrate Perimeter": "معايرة المحيط",
    "Calibrate Area": "منطقة المعايرة",
    "Calibrate Radius": "معايرة نصف القطر",
    "Calibrate Volume": "معايرة الحجم"
  },
  "stepper": {
    "optional": "خياري"
  }
}
